
/*
 * -------------------------------------------------------
 * THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
 * -------------------------------------------------------
 */

/* tslint:disable */
/* eslint-disable */

export enum AnalyticsDeviceType {
    Desktop = "Desktop",
    Mobile = "Mobile",
    Tablet = "Tablet"
}

export enum AnalyticsType {
    PixelConversionsApi = "PixelConversionsApi",
    Gtm = "Gtm",
    Ga4 = "Ga4"
}

export enum Roles {
    GiveEasyAdmin = "GiveEasyAdmin",
    Agency = "Agency",
    CharityAdmin = "CharityAdmin",
    CharityUser = "CharityUser"
}

export enum CampaignType {
    Appeal = "Appeal",
    GivingDay = "GivingDay",
    P2P = "P2P",
    VirtualGift = "VirtualGift"
}

export enum AssetCategoryType {
    Image = "Image",
    Document = "Document"
}

export enum PlatformFeeType {
    DonorPays = "DonorPays",
    CharityPays = "CharityPays"
}

export enum AggregationSettingType {
    All = "All",
    Selected = "Selected",
    Individual = "Individual"
}

export enum TriggerType {
    DateTime = "DateTime",
    Amount = "Amount"
}

export enum CharityTemplateType {
    Page = "Page",
    Section = "Section"
}

export enum CharityTaxSummarySendLogStatus {
    Initiated = "Initiated",
    Processing = "Processing",
    Completed = "Completed",
    Failed = "Failed"
}

export enum CharityTaxSummaryMessageType {
    Everyone = "Everyone",
    RegularGivingsOnly = "RegularGivingsOnly"
}

export enum MergeTagType {
    Static = "Static",
    Dynamic = "Dynamic",
    Super = "Super",
    Link = "Link",
    Formula = "Formula"
}

export enum PageRedirectType {
    Page = "Page",
    Campaign = "Campaign",
    PageBucket = "PageBucket",
    Profile = "Profile",
    External = "External"
}

export enum UpdatePaymentMethodPermission {
    None = "None",
    WhenPaymentFailed = "WhenPaymentFailed",
    Anytime = "Anytime"
}

export enum ComponentType {
    ProgressBar = "ProgressBar",
    DonationForm = "DonationForm",
    Image = "Image",
    Text = "Text",
    Empty = "Empty",
    Row = "Row",
    Column = "Column",
    Video = "Video",
    CountdownTimer = "CountdownTimer",
    Header = "Header",
    Comments = "Comments",
    Footer = "Footer",
    DollarHandles = "DollarHandles",
    Button = "Button",
    SocialShare = "SocialShare",
    LoginForm = "LoginForm",
    RegisterForm = "RegisterForm",
    FundraiserButton = "FundraiserButton",
    FundraiserProfile = "FundraiserProfile",
    Leaderboard = "Leaderboard",
    PageOptions = "PageOptions",
    ProgressImage = "ProgressImage",
    VirtualGiftSection = "VirtualGiftSection",
    VirtualGiftAmountSelector = "VirtualGiftAmountSelector",
    VirtualGiftPersonalisation = "VirtualGiftPersonalisation",
    VirtualGiftPreviewImage = "VirtualGiftPreviewImage",
    VirtualGiftPaymentForm = "VirtualGiftPaymentForm",
    VirtualGiftItemDownload = "VirtualGiftItemDownload",
    PostDonationForm = "PostDonationForm"
}

export enum CommentsLayout {
    VERTICAL = "VERTICAL",
    HORIZONTAL = "HORIZONTAL"
}

export enum DonationFrequency {
    ONE_TIME = "ONE_TIME",
    WEEKLY = "WEEKLY",
    FORTNIGHTLY = "FORTNIGHTLY",
    EVERY_4_WEEKS = "EVERY_4_WEEKS",
    MONTHLY = "MONTHLY",
    QUARTERLY = "QUARTERLY",
    YEARLY = "YEARLY"
}

export enum ExtraFieldType {
    Text = "Text",
    Address = "Address",
    Phone = "Phone",
    Email = "Email",
    Comments = "Comments",
    Custom = "Custom",
    Profile = "Profile",
    DedicateTo = "DedicateTo"
}

export enum CountdownTimerVariation {
    Full = "Full",
    Compact = "Compact"
}

export enum ComponentDirection {
    BottomToTop = "BottomToTop",
    TopToBottom = "TopToBottom",
    LeftToRight = "LeftToRight",
    RightToLeft = "RightToLeft"
}

export enum CustomFieldType {
    DateOfBirth = "DateOfBirth",
    Address = "Address",
    Custom = "Custom"
}

export enum CustomFieldElementType {
    InputText = "InputText",
    TextArea = "TextArea",
    RadioButton = "RadioButton",
    MultiSelect = "MultiSelect",
    SingleSelect = "SingleSelect",
    Dropdown = "Dropdown",
    DatePicker = "DatePicker",
    Checkbox = "Checkbox",
    Hidden = "Hidden",
    Switch = "Switch"
}

export enum ProfileStatus {
    Active = "Active",
    Approved = "Approved"
}

export enum ProfileQueryOrderType {
    DateDescending = "DateDescending",
    TotalDescending = "TotalDescending",
    DateAscending = "DateAscending"
}

export enum ProfileEntity {
    Single = "Single",
    Group = "Group"
}

export enum DonationFrequencyFilter {
    OnceOff = "OnceOff",
    Recurring = "Recurring"
}

export enum GivingStatus {
    Incomplete = "Incomplete",
    Succeeded = "Succeeded",
    Failed = "Failed",
    Refunded = "Refunded",
    PartiallyRefunded = "PartiallyRefunded",
    Pending = "Pending",
    Cancelled = "Cancelled",
    Unknown = "Unknown"
}

export enum PaymentMethodType {
    CreditCard = "CreditCard",
    ApplePay = "ApplePay",
    GooglePay = "GooglePay",
    PayPal = "PayPal",
    DirectDebit = "DirectDebit",
    Offline = "Offline"
}

export enum GivingDonationFrequency {
    OneTime = "OneTime",
    Weekly = "Weekly",
    Fortnightly = "Fortnightly",
    Every4Weeks = "Every4Weeks",
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Yearly = "Yearly"
}

export enum GivingReceiptOptionSetting {
    Always = "Always",
    None = "None"
}

export enum PageStatusType {
    Draft = "Draft",
    Published = "Published"
}

export enum PageType {
    DonationPage = "DonationPage",
    ThankYouPage = "ThankYouPage",
    Receipt = "Receipt",
    SingleProfile = "SingleProfile",
    GroupProfile = "GroupProfile",
    Login = "Login",
    Register = "Register",
    FundraiserWelcomeEmail = "FundraiserWelcomeEmail",
    EmbeddedDonationForm = "EmbeddedDonationForm"
}

export enum TemplateType {
    Charity = "Charity",
    GiveEasy = "GiveEasy",
    FED = "FED"
}

export enum ComponentTypeInput {
    ImageElement = "ImageElement",
    ProgressBarElement = "ProgressBarElement",
    DonationFormElement = "DonationFormElement",
    CountdownTimerElement = "CountdownTimerElement",
    CommentsElement = "CommentsElement",
    VideoElement = "VideoElement",
    DollarHandlesElement = "DollarHandlesElement",
    ButtonElement = "ButtonElement",
    TextElement = "TextElement",
    RowElement = "RowElement",
    ColumnElement = "ColumnElement",
    CustomFieldElement = "CustomFieldElement",
    HeaderElement = "HeaderElement",
    FooterElement = "FooterElement",
    EmptyElement = "EmptyElement",
    SocialShareElement = "SocialShareElement",
    LoginFormElement = "LoginFormElement",
    RegisterFormElement = "RegisterFormElement",
    FundraiserButtonElement = "FundraiserButtonElement",
    FundraiserProfileElement = "FundraiserProfileElement",
    LeaderboardElement = "LeaderboardElement",
    PageOptionsElement = "PageOptionsElement",
    ProgressImageElement = "ProgressImageElement",
    VirtualGiftSectionElement = "VirtualGiftSectionElement",
    PostDonationFormElement = "PostDonationFormElement"
}

export enum AccountType {
    Standard = "Standard",
    Express = "Express",
    Custom = "Custom"
}

export enum PaymentChargeType {
    Direct = "Direct",
    Destination = "Destination"
}

export enum PaymentProviderType {
    PayPal = "PayPal",
    StripeStandard = "StripeStandard",
    StripeCustom = "StripeCustom",
    Offline = "Offline"
}

export enum PaymentCardType {
    Visa = "Visa",
    Amex = "Amex",
    Mastercard = "Mastercard"
}

export enum GivingType {
    Internal = "Internal",
    Offline = "Offline",
    Facebook = "Facebook"
}

export enum GivingFrequencyType {
    OneOff = "OneOff",
    Recurring = "Recurring"
}

export enum PayoutStatus {
    Processing = "Processing",
    Succeeded = "Succeeded",
    Failed = "Failed"
}

export enum Mode {
    Live = "Live",
    Test = "Test"
}

export enum SubscriptionInvoiceStatus {
    Draft = "Draft",
    Open = "Open",
    Paid = "Paid",
    Uncollectible = "Uncollectible",
    Void = "Void",
    NeedsEnrichment = "NeedsEnrichment",
    Refunded = "Refunded",
    PartiallyRefunded = "PartiallyRefunded"
}

export enum SubscriptionStatus {
    Incomplete = "Incomplete",
    IncompleteExpired = "IncompleteExpired",
    Trialing = "Trialing",
    Active = "Active",
    PastDue = "PastDue",
    Cancelled = "Cancelled",
    Unpaid = "Unpaid",
    Paused = "Paused"
}

export enum SubscriptionReceiptOptionSetting {
    Always = "Always",
    InitialOnly = "InitialOnly",
    None = "None"
}

export interface AnalyticsInput {
    userAgent?: Nullable<string>;
    deviceType?: Nullable<AnalyticsDeviceType>;
    hasGoogleAnalytics?: Nullable<boolean>;
    hasFbPixel?: Nullable<boolean>;
    deviceUUID?: Nullable<string>;
    isLocalStorageAllowed?: Nullable<boolean>;
    fbp?: Nullable<string>;
    fbc?: Nullable<string>;
    campaignId?: Nullable<string>;
    pageId?: Nullable<string>;
    charityId?: Nullable<string>;
    isLiveMode?: Nullable<boolean>;
    donationPageUrl?: Nullable<string>;
    pixelId?: Nullable<string>;
    eventId?: Nullable<string>;
    isConversionsApi?: Nullable<boolean>;
}

export interface IdentityPartnerSettingInput {
    webhookUrl: string;
    settingId?: Nullable<string>;
}

export interface RaiserEdgeIntegrationSettingInput {
    primarySubscriptionKey: string;
    secondarySubscriptionKey: string;
    callbackUrl: string;
    clientId: string;
    clientSecret: string;
}

export interface PixelConversionsApiIntegrationSettingInput {
    name: string;
    pixelId: string;
    conversionsApiToken?: Nullable<string>;
    testEventCode?: Nullable<string>;
}

export interface GtmIntegrationSettingInput {
    name: string;
    tagId: string;
}

export interface Ga4IntegrationSettingInput {
    name: string;
    measurementId: string;
}

export interface UpdatePixelConversionsApiIntegrationSettingInput {
    settingId: string;
    name?: Nullable<string>;
    testEventCode?: Nullable<string>;
}

export interface UpdateGa4IntegrationSettingInput {
    settingId: string;
    name?: Nullable<string>;
}

export interface UpdateGtmIntegrationSettingInput {
    settingId: string;
    name?: Nullable<string>;
}

export interface DeleteAnalyticsSettingInput {
    settingId: string;
    type?: Nullable<AnalyticsType>;
}

export interface SelectCharityInput {
    auth0Id: string;
    charityId: string;
}

export interface CreateBrandingInput {
    isDefault: boolean;
    name: string;
    logoFileContentType: string;
    value: string;
}

export interface UpdateBrandingInput {
    brandingId: string;
    value: string;
    saveAsDefault?: Nullable<boolean>;
}

export interface CreateCampaignInput {
    title: string;
    goal?: Nullable<number>;
    startAt?: Nullable<string>;
    endAt?: Nullable<string>;
    type: CampaignType;
}

export interface DuplicateCampaignInput {
    campaignId: string;
    campaign: CreateCampaignInput;
    pagesToDuplicate: string[];
    duplicateSettings: boolean;
}

export interface DeleteCampaignInput {
    campaignId: string;
}

export interface AddCampaignDomainInput {
    campaignId: string;
    campaignSlug: string;
}

export interface SetDefaultCampaignPageInput {
    campaignId: string;
    pageId: string;
}

export interface SetCampaignPlatformFeeTypeInput {
    campaignId: string;
    platformFeeType: PlatformFeeType;
}

export interface SetCampaignPaymentProviderSettingsInput {
    campaignId: string;
    paymentProviderId: string;
}

export interface SetThankYouPageReferencesInput {
    campaignId: string;
    pageIds: string[];
    thankYouPageId: string;
}

export interface SetReceiptPageReferencesInput {
    campaignId: string;
    pageIds: string[];
    receiptPageId: string;
}

export interface SetPageReferencesInput {
    campaignId: string;
    pageIdsForThankYou: string[];
    pageIdsForReceipt: string[];
    thankYouPageId: string;
    receiptPageId: string;
}

export interface ProgressBarGoalInput {
    goal: number;
    index: number;
}

export interface ProgressBarAggregationSettingItemInput {
    groupId: string;
    groupName?: Nullable<string>;
    startVisibleTime?: Nullable<DateTime>;
    endVisibleTime?: Nullable<DateTime>;
    isGoalHidden?: Nullable<boolean>;
    progressBarGoals?: Nullable<ProgressBarGoalInput[]>;
    pageIds: string[];
    offset?: Nullable<number>;
    pageBucketIds?: Nullable<string[]>;
    dataSources?: Nullable<string[]>;
    isAllPagesLinked?: Nullable<boolean>;
    hideWhenMatchedGivingActive?: Nullable<boolean>;
}

export interface CommentAggregationSettingItemInput {
    groupId: string;
    groupName?: Nullable<string>;
    startVisibleTime?: Nullable<DateTime>;
    endVisibleTime?: Nullable<DateTime>;
    amountToShowOver?: Nullable<number>;
    pageIds: string[];
    pageBucketIds?: Nullable<string[]>;
    dataSources?: Nullable<string[]>;
    isAllPagesLinked?: Nullable<boolean>;
}

export interface MatchedGivingAggregationSettingItemInput {
    groupId: string;
    groupName?: Nullable<string>;
    matchedGivingSettingIds: string[];
    pageIds: string[];
    pageBucketIds?: Nullable<string[]>;
}

export interface CountdownTimerAggregationSettingItemInput {
    groupId: string;
    groupName?: Nullable<string>;
    finishTime?: Nullable<DateTime>;
    startVisibleTime?: Nullable<DateTime>;
    endVisibleTime?: Nullable<DateTime>;
    pageIds: string[];
    pageBucketIds?: Nullable<string[]>;
    bonusFinishTimes?: Nullable<DateTime[]>;
}

export interface CampaignAnalyticsSettingsInput {
    campaignId: string;
    pixelConversionsApi?: Nullable<CampaignPixelSettingInput>;
    gtm?: Nullable<CampaignGtmSettingInput>;
    ga4?: Nullable<CampaignGa4SettingInput>;
}

export interface CampaignPixelSettingInput {
    pixelSettingId?: Nullable<string>;
    isDisabled?: Nullable<boolean>;
}

export interface CampaignGtmSettingInput {
    gtmSettingId?: Nullable<string>;
    isDisabled?: Nullable<boolean>;
}

export interface CampaignGa4SettingInput {
    ga4SettingId?: Nullable<string>;
    isDisabled?: Nullable<boolean>;
}

export interface SetEmailSettingItemInput {
    campaignId: string;
    receiptPageId: string;
    subject?: Nullable<string>;
}

export interface SetEmailReceiptOptionsInput {
    campaignId: string;
    givingReceiptOption: GivingReceiptOptionSetting;
    subscriptionReceiptOption: SubscriptionReceiptOptionSetting;
}

export interface SetCampaignEmailSettingInput {
    campaignId: string;
    receiptSubjects?: Nullable<SetEmailSettingSubjectItemInput[]>;
    givingReceiptOption?: Nullable<GivingReceiptOptionSetting>;
    subscriptionReceiptOption?: Nullable<SubscriptionReceiptOptionSetting>;
    sendPdfReceipt?: Nullable<boolean>;
}

export interface SetEmailSettingSubjectItemInput {
    receiptPageId: string;
    subject?: Nullable<string>;
}

export interface DateTimeTriggerInput {
    dateTimeStart: DateTime;
    pageId: string;
    amountTriggers: AmountTriggerInput[];
}

export interface AmountTriggerInput {
    amountStart: number;
    pageId: string;
}

export interface CampaignTriggerInput {
    dateTimeTriggers: DateTimeTriggerInput[];
    campaignId: string;
    campaignTriggerId?: Nullable<string>;
    pageBucketId: string;
}

export interface CreateTemplateInput {
    pageType: PageType;
    type: CharityTemplateType;
    layout: PageLayoutInput;
    htmlLayout?: Nullable<string>;
    name: string;
    screenshotImageUrl?: Nullable<string>;
}

export interface UpdateTemplateInput {
    id: string;
    layout?: Nullable<PageLayoutInput>;
    htmlLayout?: Nullable<string>;
    name?: Nullable<string>;
    screenshotImageUrl?: Nullable<string>;
}

export interface CreateCharityInput {
    name: string;
    abn?: Nullable<string>;
    auth0Id: string;
}

export interface CreateUserForCharityInput {
    firstName: string;
    lastName: string;
    email: string;
    roleId: string;
}

export interface SendCharityTaxSummaryInput {
    financialYear: number;
    taxSummarySetting: CharityTaxSummaryMessageType;
    isLiveMode: boolean;
}

export interface CreatePaypalReferralLinkInput {
    mode: Mode;
    merchantEmail: string;
}

export interface AddPayPalByReferralInput {
    mode: Mode;
    merchantId: string;
    merchantEmail: string;
}

export interface CharityStripeSettingsInput {
    accountId: string;
    label: string;
}

export interface CharityPayPalSettingsInput {
    merchantEmail: string;
    merchantId: string;
    label: string;
}

export interface CharityDetailInput {
    abn: string;
    name: string;
    phone?: Nullable<string>;
    email?: Nullable<string>;
    description?: Nullable<string>;
    logoUrl?: Nullable<string>;
    reversedLogoUrl?: Nullable<string>;
    faviconUrl?: Nullable<string>;
    isDgrEndorsed: boolean;
    sendPdfReceipt: boolean;
    autoSendTaxSummaryEmailDate?: Nullable<string>;
}

export interface ExchangeStripeOAuthInput {
    code: string;
    state: string;
}

export interface CharityPageRedirectionSettingsInput {
    id: string;
    to?: Nullable<CharityPageRedirectionSettingItemInput>;
    externalTo?: Nullable<string>;
    from: CharityPageRedirectionSettingItemInput[];
}

export interface CharityPageRedirectionSettingItemInput {
    id: string;
    type: PageRedirectType;
}

export interface CharityDonorPortalRegularGivingPermissionsInput {
    canEditName: boolean;
    canEditAmount: boolean;
    canEditFrequency: boolean;
    canEditDonationEndDate: boolean;
    canEditNextPaymentDate: boolean;
    canCancelDonation: boolean;
    canPauseDonation: boolean;
    canResumeDonation: boolean;
    updatePaymentDetails: UpdatePaymentMethodPermission;
}

export interface CharityDonorPortalPermissionsInput {
    regularGivingPermissions?: Nullable<CharityDonorPortalRegularGivingPermissionsInput>;
}

export interface CommentInput {
    paymentTransactionId?: Nullable<string>;
    paymentSubscriptionId?: Nullable<string>;
    message?: Nullable<string>;
    fullName: string;
    isPIIPublic: boolean;
    isLiveMode?: Nullable<boolean>;
    charityId: string;
    profileId?: Nullable<string>;
    dedicateeName?: Nullable<string>;
    dedicateeEmail?: Nullable<string>;
    organisationName?: Nullable<string>;
}

export interface CommentsQueryInput {
    charityId: string;
    campaignId: string;
    pageId?: Nullable<string>;
    pageIds?: Nullable<string[]>;
    isLiveMode?: Nullable<boolean>;
    profileId?: Nullable<string>;
    includeMatchedAmount?: Nullable<boolean>;
    hasFundraiserSupported?: Nullable<boolean>;
    pagination?: Nullable<PaginationQuery>;
    onlyDedicatedComments?: Nullable<boolean>;
}

export interface QuickPayValuesInput {
    charityId: string;
    transactionId: string;
    organisation?: Nullable<string>;
    firstName: string;
    lastName: string;
    address?: Nullable<AddressInput>;
    fullAddress?: Nullable<string>;
    phone?: Nullable<string>;
    customFields?: Nullable<FormCustomFieldInput[]>;
}

export interface SubmitFormValuesInput {
    charityId: string;
    formId: string;
    formValues?: Nullable<FormCustomFieldInput[]>;
}

export interface SubmitPostDonationFormValuesInput {
    charityId: string;
    transactionId?: Nullable<string>;
    paymentSubscriptionId?: Nullable<string>;
    mobile?: Nullable<string>;
    address?: Nullable<AddressInput>;
    customFields?: Nullable<FormCustomFieldInput[]>;
}

export interface FormCustomFieldInput {
    customFieldSettingId?: Nullable<string>;
    name: string;
    values: string[];
}

export interface AddressInput {
    addressLine1?: Nullable<string>;
    addressLine2?: Nullable<string>;
    city?: Nullable<string>;
    state?: Nullable<string>;
    postcode?: Nullable<string>;
    country?: Nullable<string>;
}

export interface CustomFieldValueInput {
    key: string;
    value: string;
}

export interface CustomFieldSettingInput {
    id?: Nullable<string>;
    name: string;
    description?: Nullable<string>;
    type: CustomFieldType;
    elementType: CustomFieldElementType;
    defaultValue?: Nullable<string>;
    acceptedValues?: Nullable<CustomFieldValueInput[]>;
}

export interface DonorSummaryInput {
    email: string;
    startDate: DateTime;
    endDate: DateTime;
    isLiveMode: boolean;
}

export interface UpdateProfileInput {
    campaignId: string;
    profileId: string;
    name?: Nullable<string>;
    description?: Nullable<string>;
    goal?: Nullable<number>;
    isActive?: Nullable<boolean>;
    slug?: Nullable<string>;
    logoUrl?: Nullable<string>;
    isDeleted?: Nullable<boolean>;
    isApproved?: Nullable<boolean>;
    isGivingNotificationEnabled?: Nullable<boolean>;
}

export interface RegisterProfileInput {
    charityId: string;
    campaignId: string;
    profileCategoryId: string;
    firstName: string;
    lastName: string;
    email: string;
    profileName: string;
    description?: Nullable<string>;
    goal?: Nullable<number>;
    isGivingNotificationEnabled: boolean;
}

export interface CreateProfileCategoryInput {
    campaignId: string;
    name: string;
    pageId?: Nullable<string>;
    type: ProfileEntity;
}

export interface SetFundraiserRegistrationNotificationsForProfileInput {
    campaignId: string;
    emailValues?: Nullable<FundraiserRegistrationEmailInput[]>;
    isEnabled: boolean;
}

export interface FundraiserRegistrationEmailInput {
    displayName: string;
    email: string;
}

export interface GivingsQueryInput {
    pageNumber: number;
    pageSize?: Nullable<number>;
    filter?: Nullable<GivingsFilterInput>;
    startDate?: Nullable<string>;
    endDate?: Nullable<string>;
}

export interface GivingsFilterInput {
    status?: Nullable<GivingStatus>;
    paymentMethod?: Nullable<PaymentMethodType>;
    mode?: Nullable<Mode>;
    donationFrequency?: Nullable<DonationFrequencyFilter>;
    search?: Nullable<string>;
}

export interface AggregatedGivingsInput {
    start: DateTime;
    end: DateTime;
    timezoneOffsetInMinutes: number;
    isLiveMode?: Nullable<boolean>;
}

export interface ResendReceiptInput {
    givingId: string;
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    email: string;
}

export interface CampaignMatchedGivingSettingInput {
    campaignId: string;
    matchedGivingSettingId?: Nullable<string>;
    name: string;
    startAt: string;
    endAt?: Nullable<string>;
    rounds: CampaignMatchedGivingSettingItemInput[];
}

export interface CampaignMatchedGivingSettingItemInput {
    multiplier: number;
    startFundRange: number;
    endFundRange: number;
}

export interface AddMergeFieldInput {
    name: string;
    description?: Nullable<string>;
}

export interface SavePageMetadataInput {
    campaignId: string;
    pageId: string;
    ogTitle?: Nullable<string>;
    ogDescription?: Nullable<string>;
    ogImage?: Nullable<string>;
}

export interface ComponentsInput {
    imageElements?: Nullable<ImageInput[]>;
    progressBarElements?: Nullable<ProgressBarInput[]>;
    donationFormElements?: Nullable<DonationFormInput[]>;
    countdownTimerElements?: Nullable<CountdownTimerInput[]>;
    commentsElements?: Nullable<CommentsInput[]>;
    videoElements?: Nullable<VideoInput[]>;
    dollarHandlesElements?: Nullable<DollarHandlesInput[]>;
    buttonElements?: Nullable<ButtonInput[]>;
    textElements?: Nullable<TextInput[]>;
    rowElements?: Nullable<RowInput[]>;
    columnElements?: Nullable<ColumnInput[]>;
    customFieldElements?: Nullable<CustomFieldElementInput[]>;
    socialShareElements?: Nullable<SocialShareInput[]>;
    fundraiserButtonElements?: Nullable<FundraiserButtonInput[]>;
    loginFormElements?: Nullable<LoginFormInput[]>;
    registerFormElements?: Nullable<RegisterFormInput[]>;
    fundraiserProfileElements?: Nullable<FundraiserProfileInput[]>;
    leaderboardElements?: Nullable<LeaderboardInput[]>;
    pageOptionsElements?: Nullable<PageOptionsInput[]>;
    progressImageElements?: Nullable<ProgressImageInput[]>;
    virtualGiftSectionElements?: Nullable<VirtualGiftSectionInput[]>;
    postDonationFormElements?: Nullable<PostDonationFormInput[]>;
}

export interface OrderComponentInput {
    componentId: string;
    children?: Nullable<OrderComponentInput[]>;
    displayIndex: number;
}

export interface ImageInput {
    componentId: string;
    type: ComponentTypeInput;
    url?: Nullable<string>;
    alt?: Nullable<string>;
    mergeFieldId?: Nullable<string>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface PageOptionsInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    siteTitle?: Nullable<string>;
    faviconUrl?: Nullable<string>;
}

export interface ProgressImageInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents: JSON;
}

export interface VirtualGiftSectionInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents: JSON;
}

export interface PostDonationFormInput {
    componentId: string;
    type: ComponentTypeInput;
    buttonText: string;
    extraFields: ExtraFieldInput[];
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
}

export interface BonusGoalInput {
    index: number;
    text?: Nullable<TextInput>;
    isTickHidden?: Nullable<boolean>;
    showPastGoals?: Nullable<boolean>;
    customTickUrl?: Nullable<string>;
    customTickColor?: Nullable<string>;
}

export interface ProgressBarInput {
    componentId: string;
    type: ComponentTypeInput;
    goals?: Nullable<number[]>;
    bonusGoals?: Nullable<BonusGoalInput[]>;
    start?: Nullable<DateTime>;
    end?: Nullable<DateTime>;
    title?: Nullable<string>;
    text?: Nullable<TextInput>;
    subtitle?: Nullable<string>;
    hideOnEnd?: Nullable<boolean>;
    hideBeforeStart?: Nullable<boolean>;
    hideOnGoalReached?: Nullable<boolean>;
    hideWhenMatchedGivingActive?: Nullable<boolean>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    isAllPagesLinked?: Nullable<boolean>;
    linkedPageIds?: Nullable<string[]>;
    offset?: Nullable<number>;
}

export interface DonationFormInput {
    componentId: string;
    type: ComponentTypeInput;
    title?: Nullable<string>;
    text?: Nullable<TextInput>;
    donationFrequency: DonationFrequency[];
    donationFrequencyDefault?: Nullable<number>;
    dollarHandles: DollarHandleInput[];
    dollarHandlesDefault?: Nullable<number>;
    matchedGiving?: Nullable<MatchedGivingInput>;
    legalUrl?: Nullable<string>;
    styles?: Nullable<JSON>;
    extraFields: ExtraFieldInput[];
    minimumAmount?: Nullable<number>;
    mobileStyles?: Nullable<JSON>;
}

export interface ExtraFieldInput {
    type: ExtraFieldType;
    name: string;
    label: string;
    isRequired: boolean;
    isHidden?: Nullable<boolean>;
    order?: Nullable<number>;
    description?: Nullable<string>;
    defaultValue?: Nullable<string>;
    placeholder?: Nullable<string>;
    customField?: Nullable<CustomFieldInput>;
    conditionalFields?: Nullable<ExtraFieldInput[]>;
}

export interface CustomFieldInput {
    id: string;
    name: string;
    fieldDescription?: Nullable<string>;
    elementType: CustomFieldElementType;
    acceptedValues?: Nullable<CustomFieldValueInput[]>;
}

export interface CustomFieldElementInput {
    customFieldSettingId: string;
    label: string;
    fieldDescription?: Nullable<string>;
    fieldType: CustomFieldType;
    elementType: CustomFieldElementType;
    acceptedValues?: Nullable<CustomFieldValueInput[]>;
    isRequired: boolean;
    defaultValue?: Nullable<string>;
}

export interface DollarHandleInput {
    amount: number;
    isPersonalised?: Nullable<boolean>;
    imageUrl?: Nullable<string>;
    description?: Nullable<string>;
    text?: Nullable<TextInput>;
    hasImage?: Nullable<boolean>;
    hasDescription?: Nullable<boolean>;
}

export interface MatchedGivingInput {
    multiplier: number;
    accentColor?: Nullable<ColorInput>;
    dollarCap?: Nullable<number>;
}

export interface CountdownTimerInput {
    componentId: string;
    finish?: Nullable<DateTime>;
    start?: Nullable<DateTime>;
    end?: Nullable<DateTime>;
    hideOnEnd?: Nullable<boolean>;
    hideBeforeStart?: Nullable<boolean>;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface VideoInput {
    componentId: string;
    type: ComponentTypeInput;
    title?: Nullable<string>;
    text?: Nullable<TextInput>;
    url?: Nullable<string>;
    position?: Nullable<Nullable<number>[]>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface TextInput {
    componentId: string;
    type: ComponentTypeInput;
    textValue: string;
    htmlText?: Nullable<string>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface CommentsInput {
    componentId: string;
    type: ComponentTypeInput;
    showAmount: boolean;
    showMessage: boolean;
    showTotal: boolean;
    showViewAll: boolean;
    layout: CommentsLayout;
    start?: Nullable<DateTime>;
    end?: Nullable<DateTime>;
    hideBeforeStart?: Nullable<boolean>;
    hideOnEnd?: Nullable<boolean>;
    amountToShowOver?: Nullable<number>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    isAllPagesLinked?: Nullable<boolean>;
    linkedPageIds?: Nullable<string[]>;
}

export interface ColumnInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface RowInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface HeaderInput {
    componentId: string;
    type: ComponentTypeInput;
    hasDonateButton: boolean;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface FooterInput {
    componentId: string;
    type: ComponentTypeInput;
    taxDeductibleText?: Nullable<string>;
    taxDeductible?: Nullable<TextInput>;
    keyInformationText?: Nullable<string>;
    keyInformation?: Nullable<TextInput>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface DollarHandlesInput {
    componentId: string;
    type: ComponentTypeInput;
    dollarHandles: DollarHandleInput[];
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    hasImage?: Nullable<boolean>;
    hasDescription?: Nullable<boolean>;
}

export interface ButtonInput {
    componentId: string;
    type: ComponentTypeInput;
    text: string;
    url?: Nullable<string>;
    target?: Nullable<string>;
    buttonType: string;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface SocialShareInput {
    componentId: string;
    type: ComponentTypeInput;
    hasLink?: Nullable<boolean>;
    hasTwitter?: Nullable<boolean>;
    hasFacebook?: Nullable<boolean>;
    hasEmail?: Nullable<boolean>;
    hasWhatsApp?: Nullable<boolean>;
    hasLinkedIn?: Nullable<boolean>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface LoginFormInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents: JSON;
}

export interface RegisterFormInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents: JSON;
    extraFields?: Nullable<ExtraFieldInput[]>;
}

export interface FundraiserButtonInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    loginForm: LoginFormInput;
    registerForm: RegisterFormInput;
}

export interface FundraiserProfileInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents: JSON;
}

export interface LeaderboardInput {
    componentId: string;
    type: ComponentTypeInput;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents: JSON;
}

export interface ColorInput {
    hex: string;
    rgb: RGBColorInput;
}

export interface RGBColorInput {
    a?: Nullable<number>;
    b: number;
    g: number;
    r: number;
}

export interface PageLayoutInput {
    branding: string;
    components: ComponentsInput;
    desktop: OrderComponentInput[];
    mobile?: Nullable<OrderComponentInput[]>;
    header?: Nullable<HeaderInput>;
    footer?: Nullable<FooterInput>;
    htmlLayout?: Nullable<string>;
}

export interface InitCampaignInput {
    campaignId: string;
    templateId: string;
    campaignType: CampaignType;
    templateType: TemplateType;
}

export interface CreatePageInput {
    campaignId: string;
    pageType: PageType;
    pageLayout?: Nullable<PageLayoutInput>;
    htmlLayout?: Nullable<string>;
    pageName?: Nullable<string>;
}

export interface CreatePageStateInput {
    campaignId: string;
    pageLayout?: Nullable<PageLayoutInput>;
    htmlLayout?: Nullable<string>;
    pageBucketId?: Nullable<string>;
    pageName?: Nullable<string>;
    isPartOfGivingDayInit?: Nullable<boolean>;
}

export interface CreatePageBucketInput {
    campaignId: string;
    pageId: string;
}

export interface SaveDraftInput {
    id: string;
    pageName?: Nullable<string>;
    pageType: PageType;
    pageLayout: PageLayoutInput;
    htmlLayout?: Nullable<string>;
    screenshotImageUrl?: Nullable<string>;
    name: string;
    charityPageTemplateId?: Nullable<string>;
    charityPageTemplateVersion?: Nullable<number>;
}

export interface SaveDetailsInput {
    id: string;
    pageType: PageType;
    pageName?: Nullable<string>;
    pageSlug?: Nullable<string>;
    screenshotImageUrl?: Nullable<string>;
}

export interface DuplicatePageStateInput {
    campaignId: string;
    pageId: string;
    pageBucketId: string;
    pageName?: Nullable<string>;
}

export interface DuplicatePageInput {
    campaignId: string;
    pageType: PageType;
    pageId: string;
}

export interface PublishPageInput {
    campaignId: string;
    ids: string[];
}

export interface DeletePageInput {
    campaignId: string;
    pageId: string;
    pageType: PageType;
}

export interface AddPageSlugsForCampaignInput {
    campaignId: string;
    slugs: PageSlugsDetailsInput[];
}

export interface PageSlugsDetailsInput {
    pageId: string;
    pageSlug: string;
}

export interface AddPageBucketSlugsForCampaignInput {
    campaignId: string;
    slugs: PageBucketSlugsDetailsInput[];
}

export interface PageBucketSlugsDetailsInput {
    pageBucketId: string;
    pageBucketSlug: string;
}

export interface SendTestReceiptInput {
    campaignId: string;
    receiptPageId: string;
    to: string;
}

export interface CreatePaymentIntentInput {
    donationFormAmount: number;
    currency: string;
    charityId: string;
    campaignId: string;
    pageId: string;
    pageBucketId?: Nullable<string>;
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    email: string;
    paymentMethodType: PaymentMethodType;
    donationPageUrl: string;
    isLiveMode?: Nullable<boolean>;
    isDonorChooseToPayFee?: Nullable<boolean>;
    donorPaysAmount?: Nullable<number>;
    fbc?: Nullable<string>;
    fbp?: Nullable<string>;
    eventId?: Nullable<string>;
    deviceUUID?: Nullable<string>;
    profileId?: Nullable<string>;
    profileName?: Nullable<string>;
}

export interface InstallmentInput {
    totalAmount?: Nullable<number>;
    totalNumberOfInstallments: number;
}

export interface CreateSubscriptionInput {
    donationFormAmount: number;
    currency: string;
    charityId: string;
    campaignId: string;
    pageId: string;
    pageBucketId?: Nullable<string>;
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    email: string;
    paymentMethodType: PaymentMethodType;
    donationPageUrl: string;
    givingFrequency: DonationFrequency;
    installment?: Nullable<InstallmentInput>;
    isLiveMode?: Nullable<boolean>;
    isDonorChooseToPayFee?: Nullable<boolean>;
    donorPaysAmount?: Nullable<number>;
    fbc?: Nullable<string>;
    fbp?: Nullable<string>;
    eventId?: Nullable<string>;
    deviceUUID?: Nullable<string>;
    profileId?: Nullable<string>;
    profileName?: Nullable<string>;
}

export interface CreateOrderInput {
    donationFormAmount: number;
    currency: string;
    charityId: string;
    campaignId: string;
    pageId: string;
    pageBucketId?: Nullable<string>;
    email: string;
    cancelUrl: string;
    returnUrl: string;
    donationPageUrl: string;
    isLiveMode?: Nullable<boolean>;
    isDonorChooseToPayFee?: Nullable<boolean>;
    donorPaysAmount?: Nullable<number>;
    fbc?: Nullable<string>;
    fbp?: Nullable<string>;
    eventId?: Nullable<string>;
    deviceUUID?: Nullable<string>;
    profileId?: Nullable<string>;
    profileName?: Nullable<string>;
}

export interface UpdatePaymentDetailsInput {
    paymentIntentId?: Nullable<string>;
    subscriptionId?: Nullable<string>;
    email?: Nullable<string>;
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    address?: Nullable<AddressInput>;
    fullAddress?: Nullable<string>;
    mobile?: Nullable<string>;
    organisation?: Nullable<string>;
    paymentCardType?: Nullable<string>;
    paymentMethodId?: Nullable<string>;
    givingFrequency?: Nullable<DonationFrequency>;
    isLiveMode?: Nullable<boolean>;
    customFields?: Nullable<FormCustomFieldInput[]>;
    paymentMethodType?: Nullable<PaymentMethodType>;
    isDonorChooseToPayFee?: Nullable<boolean>;
    donorPaysAmount?: Nullable<number>;
    donationFormAmount?: Nullable<number>;
}

export interface UpdatePaymentInput {
    paymentIntentId?: Nullable<string>;
    subscriptionId?: Nullable<string>;
    charityId: string;
    campaignId: string;
    pageId: string;
    paymentMethodType?: Nullable<PaymentMethodType>;
    isDonorChooseToPayFee?: Nullable<boolean>;
    donorPaysAmount?: Nullable<number>;
    email?: Nullable<string>;
    donationFormAmount?: Nullable<number>;
    givingFrequency?: Nullable<DonationFrequency>;
    isLiveMode?: Nullable<boolean>;
    customFields?: Nullable<FormCustomFieldInput[]>;
}

export interface CreateOfflineDonationInput {
    campaignId: string;
    pageId: string;
    amount: number;
    organisation?: Nullable<string>;
    firstName: string;
    lastName: string;
    email: string;
    comment?: Nullable<string>;
    postComment: boolean;
    sendReceipt: boolean;
    isAnonymous: boolean;
    mode: Mode;
    profileId?: Nullable<string>;
    profileName?: Nullable<string>;
    address?: Nullable<AddressInput>;
    mobile?: Nullable<string>;
}

export interface CreateManualSubscriptionInput {
    campaignId: string;
    pageId: string;
    amount: number;
    organisation?: Nullable<string>;
    firstName: string;
    lastName: string;
    email: string;
    comment?: Nullable<string>;
    receiptOption: SubscriptionReceiptOptionSetting;
    isAnonymous: boolean;
    mode: Mode;
    profileId?: Nullable<string>;
    profileName?: Nullable<string>;
    address?: Nullable<AddressInput>;
    mobile?: Nullable<string>;
    stripeCustomerId: string;
    paymentMethodId: string;
    nextPaymentDate: string;
    givingFrequency: DonationFrequency;
}

export interface CreateManualDonationInput {
    campaignId: string;
    pageId: string;
    amount: number;
    organisation?: Nullable<string>;
    firstName: string;
    lastName: string;
    email: string;
    comment?: Nullable<string>;
    receiptOption: GivingReceiptOptionSetting;
    isAnonymous: boolean;
    mode: Mode;
    profileId?: Nullable<string>;
    profileName?: Nullable<string>;
    address?: Nullable<AddressInput>;
    mobile?: Nullable<string>;
    stripeCustomerId: string;
    paymentMethodId: string;
}

export interface PaginationQuery {
    pageNumber: number;
    pageSize: number;
    search?: Nullable<string>;
}

export interface SubscriptionsQueryInput {
    pageNumber: number;
    pageSize?: Nullable<number>;
    filter?: Nullable<SubscriptionsFilterInput>;
    startDate?: Nullable<string>;
    endDate?: Nullable<string>;
}

export interface SubscriptionsFilterInput {
    status?: Nullable<SubscriptionStatus>;
    mode?: Nullable<Mode>;
    donationFrequency?: Nullable<GivingDonationFrequency>;
    search?: Nullable<string>;
}

export interface UpdateSubscriptionAdminInput {
    paymentSubscriptionId: string;
    externalSubscriptionId: string;
    personalDetails?: Nullable<UpdateSubscriptionPersonalDetailAdminInput>;
    donationDetails?: Nullable<UpdateSubscriptionDonationDetailAdminInput>;
}

export interface UpdateSubscriptionPersonalDetailAdminInput {
    firstName: string;
    lastName: string;
    email: string;
}

export interface UpdateSubscriptionDonationDetailAdminInput {
    amount: number;
    frequency: GivingDonationFrequency;
    startDate: DateTime;
    externalSubscriptionScheduleId?: Nullable<string>;
}

export interface CancelSubscriptionInput {
    paymentSubscriptionId: string;
    externalSubscriptionId: string;
}

export interface PauseSubscriptionInput {
    paymentSubscriptionId: string;
    externalSubscriptionId: string;
    resumeAt?: Nullable<DateTime>;
}

export interface ResumeSubscriptionInput {
    paymentSubscriptionId: string;
    externalSubscriptionId: string;
}

export interface StripeSubscriptionDonorPortalLinkInput {
    paymentSubscriptionId: string;
    externalSubscriptionId: string;
}

export interface AggregationSetting {
    isAllPagesLinked?: Nullable<boolean>;
    groupSettings?: Nullable<AggregationSettingItem[]>;
}

export interface AggregationSettingItem {
    groupId: string;
    groupName?: Nullable<string>;
    pageIds: string[];
    pageBucketIds?: Nullable<string[]>;
    dataSources?: Nullable<string[]>;
    isAllPagesLinked?: Nullable<boolean>;
}

export interface Component {
    id: string;
    type: ComponentType;
    subComponents?: Nullable<JSON>;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
}

export interface IMutation {
    recordStats(input: AnalyticsInput, ip?: Nullable<string>): Nullable<boolean> | Promise<Nullable<boolean>>;
    addPixelConversionsApiSetting(input: PixelConversionsApiIntegrationSettingInput): Nullable<string> | Promise<Nullable<string>>;
    updatePixelConversionsApiSetting(input: UpdatePixelConversionsApiIntegrationSettingInput[]): Nullable<string> | Promise<Nullable<string>>;
    addGtmSetting(input: GtmIntegrationSettingInput): Nullable<string> | Promise<Nullable<string>>;
    updateGtmSetting(input: UpdateGtmIntegrationSettingInput[]): Nullable<string> | Promise<Nullable<string>>;
    addGa4Setting(input: Ga4IntegrationSettingInput): Nullable<string> | Promise<Nullable<string>>;
    updateGa4Setting(input: UpdateGa4IntegrationSettingInput[]): Nullable<string> | Promise<Nullable<string>>;
    deleteAnalyticsSetting(input: DeleteAnalyticsSettingInput): Nullable<string> | Promise<Nullable<string>>;
    approveIdentityPartnerSettings(input: IdentityPartnerSettingInput): Nullable<boolean> | Promise<Nullable<boolean>>;
    addRaiserEdgeIntegrationSetting(input: RaiserEdgeIntegrationSettingInput): Nullable<string> | Promise<Nullable<string>>;
    approveRaiserEdgeIntegrationSetting(state: string, code: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    selectCharity(input: SelectCharityInput): Nullable<boolean> | Promise<Nullable<boolean>>;
    loginDonor(email: string): string | Promise<string>;
    authenticateDonorToken(token: string): string | Promise<string>;
    createBranding(brandingInput: CreateBrandingInput): CreateBrandingResponse | Promise<CreateBrandingResponse>;
    updateBranding(brandingInput: UpdateBrandingInput): UpdateBrandingResponse | Promise<UpdateBrandingResponse>;
    createCampaign(campaignInput: CreateCampaignInput): Campaign | Promise<Campaign>;
    deleteCampaign(deleteCampaignInput: DeleteCampaignInput): string | Promise<string>;
    addCampaignDomain(addCampaignDomainInput: AddCampaignDomainInput): string | Promise<string>;
    duplicateCampaign(duplicateCampaignInput: DuplicateCampaignInput): string | Promise<string>;
    updateCampaignTitle(campaignId: string, campaignTitle: string): string | Promise<string>;
    deleteCampaignAsset(assetId: string, campaignId: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    setCampaignStripeSettings(input: SetCampaignPaymentProviderSettingsInput): SetCampaignPaymentProviderSettingsResponse | Promise<SetCampaignPaymentProviderSettingsResponse>;
    setCampaignPayPalSettings(input: SetCampaignPaymentProviderSettingsInput): SetCampaignPaymentProviderSettingsResponse | Promise<SetCampaignPaymentProviderSettingsResponse>;
    setThankYouPageReferences(input: SetThankYouPageReferencesInput): boolean | Promise<boolean>;
    setReceiptPageReferences(input: SetReceiptPageReferencesInput): boolean | Promise<boolean>;
    setProgressBarAggregationSetting(campaignId: string, input: ProgressBarAggregationSettingItemInput[]): boolean | Promise<boolean>;
    setCommentAggregationSetting(campaignId: string, input: CommentAggregationSettingItemInput[]): boolean | Promise<boolean>;
    setCountdownTimerAggregationSetting(campaignId: string, input: CountdownTimerAggregationSettingItemInput[]): boolean | Promise<boolean>;
    setMatchedGivingAggregationSetting(campaignId: string, input: MatchedGivingAggregationSettingItemInput[]): boolean | Promise<boolean>;
    setCampaignAnalyticsSettings(input: CampaignAnalyticsSettingsInput): string | Promise<string>;
    setCampaignPlatformFeeType(input: SetCampaignPlatformFeeTypeInput): Nullable<string> | Promise<Nullable<string>>;
    setDefaultCampaignPage(input: SetDefaultCampaignPageInput): boolean | Promise<boolean>;
    setEmailSettings(input: SetCampaignEmailSettingInput): boolean | Promise<boolean>;
    setEmailReceiptSetting(input: SetEmailSettingItemInput): boolean | Promise<boolean>;
    setEmailReceiptOptions(input: SetEmailReceiptOptionsInput): boolean | Promise<boolean>;
    setCampaignTriggers(input: CampaignTriggerInput): Nullable<string> | Promise<Nullable<string>>;
    createTemplate(input: CreateTemplateInput): string | Promise<string>;
    updateTemplate(input: UpdateTemplateInput): string | Promise<string>;
    deleteTemplate(id: string): string | Promise<string>;
    createCharity(charityInput: CreateCharityInput): CreateCharityResult | Promise<CreateCharityResult>;
    sendCharityTaxSummary(input: SendCharityTaxSummaryInput): boolean | Promise<boolean>;
    createUserForCharity(input: CreateUserForCharityInput, mfaJwt: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    deleteUserFromCharity(userId: string, mfaJwt: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    changeRole(userId: string, roleId: string, mfaJwt: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    setCharityStripeSettings(input: CharityStripeSettingsInput): SetPaymentProviderSettingsResponse | Promise<SetPaymentProviderSettingsResponse>;
    setCharityPayPalSettings(input: CharityPayPalSettingsInput): SetPaymentProviderSettingsResponse | Promise<SetPaymentProviderSettingsResponse>;
    setCharityDetail(input: CharityDetailInput): string | Promise<string>;
    createPaypalReferralLink(input: CreatePaypalReferralLinkInput): CreatePaypalReferralLinkResponse | Promise<CreatePaypalReferralLinkResponse>;
    addPayPalByReferral(input: AddPayPalByReferralInput): Nullable<string> | Promise<Nullable<string>>;
    setCharityPlatformFee(platformFeeType: PlatformFeeType): Nullable<string> | Promise<Nullable<string>>;
    connectStripeStandardAccountOAuth(isLiveMode: boolean): Nullable<string> | Promise<Nullable<string>>;
    exchangeStripeOAuthCode(input: ExchangeStripeOAuthInput): Nullable<string> | Promise<Nullable<string>>;
    setCharityPageRedirectionSettings(input: CharityPageRedirectionSettingsInput[]): Nullable<boolean> | Promise<Nullable<boolean>>;
    setCharityBranding(brandingId: string): boolean | Promise<boolean>;
    setCharityDonorPortalPermissions(input: CharityDonorPortalPermissionsInput): Nullable<boolean> | Promise<Nullable<boolean>>;
    postComment(comment: CommentInput): boolean | Promise<boolean>;
    submitQuickPayValues(input: QuickPayValuesInput): boolean | Promise<boolean>;
    submitFormValues(input: SubmitFormValuesInput): boolean | Promise<boolean>;
    submitPostDonationFormValues(input: SubmitPostDonationFormValuesInput): boolean | Promise<boolean>;
    addCustomFieldSetting(input: CustomFieldSettingInput): CustomFieldSetting | Promise<CustomFieldSetting>;
    updateCustomFieldSetting(input: CustomFieldSettingInput): string | Promise<string>;
    validateAndCreateCustomerPortalSession(tenantId: string, token: string, subscriptionId: string): string | Promise<string>;
    regenerateCustomerPortalSession(externalSubscriptionId: string): boolean | Promise<boolean>;
    login(email: string): string | Promise<string>;
    authenticateToken(token: string): string | Promise<string>;
    submitDonorSummary(input: DonorSummaryInput): Nullable<boolean> | Promise<Nullable<boolean>>;
    registerProfile(token: string, input: RegisterProfileInput): RegisterProfileResult | Promise<RegisterProfileResult>;
    loginProfile(charityId: string, email: string, campaignId: string): string | Promise<string>;
    authenticateProfile(charityId: string, campaignId: string, encodedToken: string): AuthenticateProfileResponse | Promise<AuthenticateProfileResponse>;
    updateProfile(token: string, input: UpdateProfileInput): boolean | Promise<boolean>;
    updateProfileAdmin(input: UpdateProfileInput): boolean | Promise<boolean>;
    createProfileCategory(input: CreateProfileCategoryInput): string | Promise<string>;
    registerEmail(charityId: string, campaignId: string, email: string): RegisterEmailResponse | Promise<RegisterEmailResponse>;
    toggleWelcomeEmailForProfile(campaignId: string, isEnabled: boolean): boolean | Promise<boolean>;
    setFundraiserRegistrationNotificationsForProfile(input: SetFundraiserRegistrationNotificationsForProfileInput): boolean | Promise<boolean>;
    toggleDonationNotificationForProfile(campaignId: string, isEnabled: boolean): boolean | Promise<boolean>;
    resendReceipt(input?: Nullable<ResendReceiptInput>): Nullable<string> | Promise<Nullable<string>>;
    addCampaignMatchedGivingSetting(input: CampaignMatchedGivingSettingInput): AddCampaignMatchedGivingSettingResult | Promise<AddCampaignMatchedGivingSettingResult>;
    addMergeField(input: AddMergeFieldInput): string | Promise<string>;
    initCampaign(initCampaignInput: InitCampaignInput): PageResponse | Promise<PageResponse>;
    createPage(createPageInput: CreatePageInput): PageResponse | Promise<PageResponse>;
    createPageState(createPageStateInput: CreatePageStateInput): PageResponse | Promise<PageResponse>;
    createPageBucket(createPageBucketInput: CreatePageBucketInput): PageResponse | Promise<PageResponse>;
    duplicatePage(duplicatePageInput: DuplicatePageInput): PageResponse | Promise<PageResponse>;
    duplicatePageState(duplicatePageStateInput: DuplicatePageStateInput): PageResponse | Promise<PageResponse>;
    saveDraft(saveDraftInput?: Nullable<SaveDraftInput>): PageResponse | Promise<PageResponse>;
    saveDetails(saveDetailsInput: SaveDetailsInput): PageResponse | Promise<PageResponse>;
    publishPage(publishPageInput?: Nullable<PublishPageInput>): PageDetail[] | Promise<PageDetail[]>;
    deletePage(deletePageInput: DeletePageInput): string | Promise<string>;
    addPageSlugsForCampaign(addPageSlugsForCampaignInput?: Nullable<AddPageSlugsForCampaignInput>): Nullable<string[]> | Promise<Nullable<string[]>>;
    addPageBucketSlugsForCampaign(addPageBucketSlugsForCampaignInput?: Nullable<AddPageBucketSlugsForCampaignInput>): Nullable<string[]> | Promise<Nullable<string[]>>;
    sendTestEmail(sendTestReceiptInput?: Nullable<SendTestReceiptInput>): Nullable<string> | Promise<Nullable<string>>;
    savePageMetadata(savePageMetadataInput?: Nullable<SavePageMetadataInput>): Nullable<boolean> | Promise<Nullable<boolean>>;
    initGivingDayCampaign(initCampaignInput: InitCampaignInput): PageResponse | Promise<PageResponse>;
    initFundraiserPages(campaignId: string): Nullable<boolean> | Promise<Nullable<boolean>>;
    savePageBucketDetails(campaignId: string, pageBucketId: string, name?: Nullable<string>): Nullable<boolean> | Promise<Nullable<boolean>>;
    createPaymentIntent(input: CreatePaymentIntentInput, ip?: Nullable<string>): CreatePaymentIntentResponse | Promise<CreatePaymentIntentResponse>;
    createOrder(input: CreateOrderInput): CreateOrderResponse | Promise<CreateOrderResponse>;
    createSubscription(input: CreateSubscriptionInput, ip?: Nullable<string>): CreateSubscriptionResponse | Promise<CreateSubscriptionResponse>;
    updatePaymentIntent(input: UpdatePaymentInput, ip?: Nullable<string>): UpdatePaymentIntentResponse | Promise<UpdatePaymentIntentResponse>;
    updateSubscription(input: UpdatePaymentInput, ip?: Nullable<string>): UpdateSubscriptionResponse | Promise<UpdateSubscriptionResponse>;
    updatePaymentIntentDetails(input: UpdatePaymentDetailsInput): UpdatePaymentIntentResponse | Promise<UpdatePaymentIntentResponse>;
    updateSubscriptionDetails(input: UpdatePaymentDetailsInput): UpdateSubscriptionResponse | Promise<UpdateSubscriptionResponse>;
    createOfflineDonation(input: CreateOfflineDonationInput): Nullable<string> | Promise<Nullable<string>>;
    createManualSubscription(input: CreateManualSubscriptionInput): Nullable<string> | Promise<Nullable<string>>;
    createManualDonation(input: CreateManualDonationInput): Nullable<string> | Promise<Nullable<string>>;
    updateSubscriptionAdmin(input: UpdateSubscriptionAdminInput): Nullable<UpdateSubscriptionAdminResponse> | Promise<Nullable<UpdateSubscriptionAdminResponse>>;
    cancelSubscription(input: CancelSubscriptionInput): Nullable<boolean> | Promise<Nullable<boolean>>;
    pauseSubscription(input?: Nullable<PauseSubscriptionInput>): Nullable<boolean> | Promise<Nullable<boolean>>;
    resumeSubscription(input?: Nullable<ResumeSubscriptionInput>): Nullable<SubscriptionStatus> | Promise<Nullable<SubscriptionStatus>>;
    createStripeSubscriptionDonorPortalLink(input: StripeSubscriptionDonorPortalLinkInput): StripeSubscriptionDonorPortalLink | Promise<StripeSubscriptionDonorPortalLink>;
    createThankYouPage(createPageInput: CreatePageInput): PageResponse | Promise<PageResponse>;
    duplicateThankYouPage(duplicatePageInput: DuplicatePageInput): PageResponse | Promise<PageResponse>;
    saveThankYouPageDraft(saveDraftInput?: Nullable<SaveDraftInput>): PageResponse | Promise<PageResponse>;
    publishThankYouPage(publishPageInput?: Nullable<PublishPageInput>): PageDetail[] | Promise<PageDetail[]>;
}

export interface PixelConversionsApiIntegrationSetting {
    pixelId: string;
    isConversionsApi: boolean;
    settingId: string;
    name: string;
    testEventCode?: Nullable<string>;
}

export interface GtmIntegrationSetting {
    tagId: string;
    settingId: string;
    name: string;
}

export interface Ga4IntegrationSetting {
    measurementId: string;
    settingId: string;
    name: string;
}

export interface MoveDataIntegrationSetting {
    settingId?: Nullable<string>;
    webhookUrl: string;
}

export interface RaiserEdgeIntegrationSetting {
    settingId?: Nullable<string>;
    primarySubscriptionKey: string;
    secondarySubscriptionKey: string;
    callbackUrl: string;
    clientId: string;
}

export interface IdentityPartnerSetting {
    items: MoveDataIntegrationSetting[];
}

export interface AnalyticsIntegrationSettings {
    pixelConversionsApiSettings: PixelConversionsApiIntegrationSetting[];
    gtmSettings: GtmIntegrationSetting[];
    ga4Settings: Ga4IntegrationSetting[];
    identityPartnerSettings?: Nullable<IdentityPartnerSetting>;
    raiserEdgeIntegrationSettings?: Nullable<RaiserEdgeIntegrationSetting[]>;
}

export interface IQuery {
    analyticsIntegrationSettings(): AnalyticsIntegrationSettings | Promise<AnalyticsIntegrationSettings>;
    claims(pagination?: Nullable<PaginationQuery>): CharityClaim[] | Promise<CharityClaim[]>;
    brandings(): Branding[] | Promise<Branding[]>;
    branding(id: string): Branding | Promise<Branding>;
    campaign(id: string): Campaign | Promise<Campaign>;
    campaigns(pagination: PaginationQuery): Campaign[] | Promise<Campaign[]>;
    campaignAssets(campaignId: string, pagination: PaginationQuery): CampaignAsset[] | Promise<CampaignAsset[]>;
    campaignDomain(campaignId: string): CampaignDomain | Promise<CampaignDomain>;
    campaignPerformance(campaignId: string, startDate: DateTime, endDate: DateTime, timezoneOffsetInMinutes: number, isLiveMode?: Nullable<boolean>): GetCampaignPerformanceStatsQueryResult | Promise<GetCampaignPerformanceStatsQueryResult>;
    campaignsOverview(campaignIds: string[], isLiveMode?: Nullable<boolean>): CampaignOverview[] | Promise<CampaignOverview[]>;
    campaignAggregateGivingStats(campaignId: string, startDate: DateTime, endDate: DateTime, timezoneOffsetInMinutes: number, isLiveMode?: Nullable<boolean>): GetCampaignPerformanceStatsQueryResult | Promise<GetCampaignPerformanceStatsQueryResult>;
    campaignAmountsByDate(campaignId: string, startDate: DateTime, endDate: DateTime, timezoneOffsetInMinutes: number, isLiveMode?: Nullable<boolean>): CampaignDonationByDateStat[] | Promise<CampaignDonationByDateStat[]>;
    campaignTopDonationAmounts(campaignId: string, startDate: DateTime, endDate: DateTime, timezoneOffsetInMinutes: number, isLiveMode?: Nullable<boolean>): CampaignDonorAmountStat[] | Promise<CampaignDonorAmountStat[]>;
    campaignPageDonationAmounts(campaignId: string, startDate: DateTime, endDate: DateTime, timezoneOffsetInMinutes: number, isLiveMode?: Nullable<boolean>): CampaignPageDonationAmountStat[] | Promise<CampaignPageDonationAmountStat[]>;
    campaignUtmTagDonationAmounts(campaignId: string, startDate: DateTime, endDate: DateTime, timezoneOffsetInMinutes: number, isLiveMode?: Nullable<boolean>): CampaignUtmTagDonationAmountStat[] | Promise<CampaignUtmTagDonationAmountStat[]>;
    campaignPaymentSettings(campaignId: string): CampaignPaymentSettings | Promise<CampaignPaymentSettings>;
    thankYouPageReferences(campaignId: string, pageId: string): string[] | Promise<string[]>;
    campaignSettings(campaignId: string): CampaignSettings | Promise<CampaignSettings>;
    aggregationSettings(campaignId: string, pageBucketId?: Nullable<string>): AggregationSettings | Promise<AggregationSettings>;
    campaignAnalyticsSettings(campaignId: string): CampaignAnalyticsSettings | Promise<CampaignAnalyticsSettings>;
    campaignTriggers(campaignId: string, pageBucketId: string): Nullable<CampaignTrigger> | Promise<Nullable<CampaignTrigger>>;
    charityTemplates(type: CharityTemplateType, pageType: PageType): CharityTemplateDetail[] | Promise<CharityTemplateDetail[]>;
    charityTemplateLayout(pageId: string): Page | Promise<Page>;
    charities(): Charity[] | Promise<Charity[]>;
    charity(): Charity | Promise<Charity>;
    charityUsers(pagination: PaginationQuery): Nullable<CharityUserWithPagination> | Promise<Nullable<CharityUserWithPagination>>;
    charityTaxSummaryStatus(financialYear: number, isLiveMode: boolean): CharityTaxSummaryStatus | Promise<CharityTaxSummaryStatus>;
    charityTaxSummaryTotalEmailCount(financialYear: number, taxSummarySettingType: CharityTaxSummaryMessageType, isLiveMode: boolean): number | Promise<number>;
    charityUserRoles(): Role[] | Promise<Role[]>;
    charityPaymentSettings(): CharityPaymentSettings | Promise<CharityPaymentSettings>;
    charityStripeCustomProviderSettings(): CharityPaymentSettings | Promise<CharityPaymentSettings>;
    charityMergeTags(): MergeFieldSetting[] | Promise<MergeFieldSetting[]>;
    charityDetail(): CharityDetail | Promise<CharityDetail>;
    charityPageRedirectionSetting(): CharityPageRedirectionSetting[] | Promise<CharityPageRedirectionSetting[]>;
    charityDonorPortalSettings(): Nullable<CharityDonorPortalSettings> | Promise<Nullable<CharityDonorPortalSettings>>;
    comments(query: CommentsQueryInput): CommentsQueryResult | Promise<CommentsQueryResult>;
    formData(formId: string): FormDataQueryResult | Promise<FormDataQueryResult>;
    customFieldSettings(): CustomFieldSetting[] | Promise<CustomFieldSetting[]>;
    donorPortalSettings(url: string): DonorPortalSlugResponse | Promise<DonorPortalSlugResponse>;
    donorProfile(): DonorProfile | Promise<DonorProfile>;
    featureFlag(flags: string[]): JSON | Promise<JSON>;
    profileData(charityId: string, campaignId: string, profileId: string): ProfileData | Promise<ProfileData>;
    leaderboard(charityId: string, campaignId: string, isLiveMode: boolean, orderBy: ProfileQueryOrderType, isApprovedOnly?: Nullable<boolean>): ProfileData[] | Promise<ProfileData[]>;
    profileCategories(campaignId: string): ProfileCategory[] | Promise<ProfileCategory[]>;
    validateToken(token: string, charityId: string, profileId?: Nullable<string>): boolean | Promise<boolean>;
    profiles(campaignId: string, isLiveMode: boolean, orderBy: ProfileQueryOrderType, isApprovedOnly?: Nullable<boolean>): ProfileData[] | Promise<ProfileData[]>;
    charityProfileCategories(): ProfileCategory[] | Promise<ProfileCategory[]>;
    givings(input: GivingsQueryInput): GivingsQueryResult | Promise<GivingsQueryResult>;
    donorGivings(input: GivingsQueryInput): DonorGivingsQueryResult | Promise<DonorGivingsQueryResult>;
    aggregatedGivings(input: AggregatedGivingsInput): Nullable<AggregatedGivings> | Promise<Nullable<AggregatedGivings>>;
    campaignMatchedGivingSettings(campaignId: string): CampaignMatchedGivingSetting[] | Promise<CampaignMatchedGivingSetting[]>;
    matchedGivingProgress(campaignId: string, matchedGivingId: string, isLiveMode: boolean): MatchedGivingProgressResult | Promise<MatchedGivingProgressResult>;
    fullMatchedGivingProgress(campaignId: string, matchedGivingId: string, isLiveMode: boolean): MatchedGivingProgressResult | Promise<MatchedGivingProgressResult>;
    matchedGivingRecords(pageSize: number, pageNumber: number, mode: Mode): MatchedGivingQueryResult | Promise<MatchedGivingQueryResult>;
    mergeFields(name?: Nullable<string>): MergeField[] | Promise<MergeField[]>;
    pageMetadata(charityId: string, campaignId: string, pageId: string): Nullable<Metadata> | Promise<Nullable<Metadata>>;
    charityMetadata(charityId: string): Nullable<CharityMetadata> | Promise<Nullable<CharityMetadata>>;
    page(id: string, campaignId?: Nullable<string>, profileId?: Nullable<string>): Page | Promise<Page>;
    pageBuckets(campaignId: string): PageBucketDetail[] | Promise<PageBucketDetail[]>;
    searchBySlug(url: string, isLiveMode: boolean): SlugResponse | Promise<SlugResponse>;
    thankYouPageIdFromId(campaignId: string, pageId: string): string | Promise<string>;
    pages(campaignId: string, pageTypes: PageType[]): PageDetail[] | Promise<PageDetail[]>;
    campaignLandingPageId(campaignId: string, isLiveMode: boolean, pageBucketId?: Nullable<string>): Nullable<string> | Promise<Nullable<string>>;
    pageLayout(pageId: string, pageType?: Nullable<PageType>): Page | Promise<Page>;
    templatePage(templateId: string, templateType: TemplateType): Nullable<Page> | Promise<Nullable<Page>>;
    sectionTemplates(pageType: PageType): JSON | Promise<JSON>;
    purl(charityId: string, campaignId: string, id?: Nullable<string>, params?: Nullable<string>): JSON | Promise<JSON>;
    purlParams(charityId: string, campaignId: string, id?: Nullable<string>, params?: Nullable<string>): JSON | Promise<JSON>;
    salesforceContact(charityId: string, contactId: string, donorId: string): Nullable<SalesforceContact> | Promise<Nullable<SalesforceContact>>;
    campaignPageMetadata(campaignId: string, pageId: string): Nullable<PageMetadata> | Promise<Nullable<PageMetadata>>;
    pagesWithPageTypes(campaignId: string, pageTypes: PageType[]): PageDetail[] | Promise<PageDetail[]>;
    capturePayment(orderId: string): boolean | Promise<boolean>;
    paymentSettings(campaignId: string, isLiveMode?: Nullable<boolean>): Nullable<PaymentSettings> | Promise<Nullable<PaymentSettings>>;
    paymentTransactions(pageSize: number, pageNumber: number, mode: Mode, startDate: string, endDate: string, paymentProviderId?: Nullable<string>): PaymentTransactionQueryResult | Promise<PaymentTransactionQueryResult>;
    payouts(pageNumber: number, pageSize: number, mode: Mode, paymentProviderId?: Nullable<string>): PayoutQueryResult | Promise<PayoutQueryResult>;
    payoutTransactions(payoutId: string): PaymentTransaction[] | Promise<PaymentTransaction[]>;
    unpaidTransactions(mode: Mode, paymentProviderId?: Nullable<string>): PaymentTransaction[] | Promise<PaymentTransaction[]>;
    unpaidBalance(mode: Mode, paymentProviderId?: Nullable<string>): Balance | Promise<Balance>;
    payout(payoutId: string): Payout | Promise<Payout>;
    previewLayout(previewId: string): PreviewQueryResult | Promise<PreviewQueryResult>;
    progressBarAmount(campaignId: string, isAllPagesLinked: boolean, pageIds?: Nullable<string[]>, isLiveMode?: Nullable<boolean>, profileId?: Nullable<string>): Nullable<ProgressBarAmount> | Promise<Nullable<ProgressBarAmount>>;
    subscriptions(input: SubscriptionsQueryInput): SubscriptionsQueryResult | Promise<SubscriptionsQueryResult>;
    donorSubscriptions(token: string, input: GivingsQueryInput): DonorSubscriptionsQueryResult | Promise<DonorSubscriptionsQueryResult>;
    thankYouPage(pageId: string): Page | Promise<Page>;
    thankYouPages(campaignId: string): PageDetail[] | Promise<PageDetail[]>;
    thankYouPageLayout(pageId: string): Page | Promise<Page>;
}

export interface CharityClaim {
    id: string;
    name: string;
    logoUrl?: Nullable<string>;
}

export interface RegisterDonorEmailResponse {
    token: string;
}

export interface Branding {
    id: string;
    isDefault: boolean;
    name: string;
    logoURL?: Nullable<string>;
    logoStyle?: Nullable<string>;
    value: string;
}

export interface CreateBrandingAPIResponse {
    brandingId: string;
}

export interface CreateBrandingResponse {
    id: string;
}

export interface UpdateBrandingResponse {
    brandingId: string;
}

export interface Campaign {
    id: string;
    title: string;
    goal?: Nullable<number>;
    startDate?: Nullable<string>;
    endDate?: Nullable<string>;
    campaignDomain?: Nullable<string>;
    platformFeeType?: Nullable<PlatformFeeType>;
    type?: Nullable<CampaignType>;
    pages?: Nullable<PageDetail[]>;
    buckets?: Nullable<PageBucketDetail[]>;
    isP2PEnabled: boolean;
}

export interface CampaignOverview {
    id: string;
    totalDonors: number;
    totalAmount: number;
    campaignSettings?: Nullable<CampaignSettings>;
    pages?: Nullable<PageDetail[]>;
    buckets?: Nullable<PageBucketDetail[]>;
}

export interface CampaignAsset {
    id: string;
    url: string;
    fileName: string;
    categoryType: AssetCategoryType;
}

export interface FindCampaignAssetsResponse {
    url: string;
    assetId: string;
    fileName: string;
    categoryType?: Nullable<AssetCategoryType>;
}

export interface CreateCampaignAPIResponse {
    campaignId: string;
    campaignTitle: string;
    goal?: Nullable<number>;
    startDate?: Nullable<string>;
    endDate?: Nullable<string>;
    campaignType: CampaignType;
}

export interface GetCampaignPerformanceStatsQueryResult {
    donationCount: number;
    averageDonationAmount: number;
    totalAmount: number;
    pageDonationAmounts: CampaignPageDonationAmountStat[];
    utmTagDonationAmounts: CampaignUtmTagDonationAmountStat[];
    donationAmounts: CampaignDonorAmountStat[];
    donationsByDates: CampaignDonationByDateStat[];
}

export interface CampaignPageDonationAmountStat {
    pageName: string;
    amount: number;
    count: number;
}

export interface CampaignUtmTagDonationAmountStat {
    tagName: string;
    tagValue: string;
    amount: number;
    count: number;
}

export interface CampaignDonorAmountStat {
    donorName: string;
    amount: number;
}

export interface CampaignDonationByDateStat {
    date: string;
    donationCount: number;
    donationAmount: number;
}

export interface CampaignDomain {
    domain: string;
    slug?: Nullable<string>;
    origin: string;
}

export interface CampaignPaymentSettings {
    platformFeeType?: Nullable<PlatformFeeType>;
    stripe?: Nullable<CharityStripeSettings>;
    paypal?: Nullable<CharityPayPalSettings>;
}

export interface PageReference {
    pageId: string;
    thankYouPageIds: string[];
    receiptPageIds: string[];
}

export interface BaseCampaignSettings {
    goal?: Nullable<number>;
    startDateTime?: Nullable<string>;
    endDateTime?: Nullable<string>;
}

export interface PreviewCampaignPaymentSettings {
    hasStripe?: Nullable<boolean>;
    hasPaypal?: Nullable<boolean>;
    platformFeeType?: Nullable<PlatformFeeType>;
}

export interface PeerToPeerPageMapItem {
    pageId?: Nullable<string>;
    categoryId?: Nullable<string>;
}

export interface PeerToPeerPageMapSettings {
    singleFundraiserPageIds?: Nullable<PeerToPeerPageMapItem[]>;
    multipleFundraiserPageIds?: Nullable<PeerToPeerPageMapItem[]>;
}

export interface PeerToPeerFundraiserRegistrationNotificationSettingValue {
    displayName: string;
    email: string;
}

export interface EmailReceiptSettingItem {
    receiptPageId: string;
    subject?: Nullable<string>;
    from?: Nullable<string>;
    replyTo?: Nullable<string>;
}

export interface ReceiptOptionSetting {
    subscriptionReceiptOption?: Nullable<SubscriptionReceiptOptionSetting>;
    givingReceiptOption?: Nullable<GivingReceiptOptionSetting>;
    sendPdfReceipt?: Nullable<boolean>;
    sendFundraiserWelcomeEmail?: Nullable<boolean>;
}

export interface EmailReceiptSettings {
    receiptOptionSetting?: Nullable<ReceiptOptionSetting>;
    items?: Nullable<EmailReceiptSettingItem[]>;
    profileRegisteredNotificationEmailsEnabled?: Nullable<boolean>;
    profileRegisteredNotificationEmails?: Nullable<PeerToPeerFundraiserRegistrationNotificationSettingValue[]>;
}

export interface CampaignSettings {
    baseSettings?: Nullable<BaseCampaignSettings>;
    pageReferences?: Nullable<PageReference[]>;
    aggregationSettings?: Nullable<AggregationSettings>;
    matchedGivingSettings?: Nullable<CampaignMatchedGivingSetting[]>;
    analyticsSettings?: Nullable<CampaignAnalyticsSettings>;
    paymentSettings?: Nullable<PreviewCampaignPaymentSettings>;
    peerToPeerPageMapSettings?: Nullable<PeerToPeerPageMapSettings>;
    campaignDomain?: Nullable<string>;
    defaultCampaignPageId?: Nullable<string>;
    emailReceiptSettings?: Nullable<EmailReceiptSettings>;
    isPeerToPeerGivingNotificationEnabled?: Nullable<boolean>;
}

export interface ApiDonationMetaPixelAnalyticSetting {
    metaPixelId?: Nullable<string>;
    isConversionsAPI?: Nullable<boolean>;
}

export interface ApiDonationGTMSetting {
    googleTagId?: Nullable<string>;
    isEnabled?: Nullable<boolean>;
}

export interface ApiDonationGa4Setting {
    ga4MeasurementId?: Nullable<string>;
    isEnabled?: Nullable<boolean>;
}

export interface ApiDonationCampaignAnalyticsSettings {
    metaPixelAnalytic?: Nullable<ApiDonationMetaPixelAnalyticSetting>;
    googleAnalytic?: Nullable<ApiDonationGTMSetting>;
    ga4Analytic?: Nullable<ApiDonationGa4Setting>;
}

export interface ApiDonationCampaignSettings {
    pageReferences: PageReference[];
    aggregationSettings?: Nullable<AggregationSettings>;
    matchedGivingSettings?: Nullable<CampaignMatchedGivingSetting[]>;
    analyticSettings?: Nullable<ApiDonationCampaignAnalyticsSettings>;
    isPeerToPeerGivingNotificationEnabled?: Nullable<boolean>;
}

export interface SetCampaignPaymentProviderSettingsResponse {
    campaignId: string;
}

export interface GetCampaignPaymentSettingsAPIResponse {
    platformFeeType?: Nullable<PlatformFeeType>;
    stripeSetting?: Nullable<CharityStripeSettings>;
    payPalSetting?: Nullable<CharityPayPalSettings>;
}

export interface AggregationSettings {
    commentSetting?: Nullable<CommentAggregationSetting>;
    progressBarSetting?: Nullable<ProgressBarAggregationSetting>;
    matchedGivingSetting?: Nullable<MatchedGivingAggregationSetting>;
    countdownTimerSetting?: Nullable<CountdownTimerAggregationSetting>;
}

export interface ProgressBarGoal {
    goal: number;
    index: number;
}

export interface ProgressBarAggregationSetting extends AggregationSetting {
    isAllPagesLinked?: Nullable<boolean>;
    groupSettings?: Nullable<ProgressBarAggregationSettingItem[]>;
}

export interface ProgressBarAggregationSettingItem extends AggregationSettingItem {
    groupId: string;
    groupName?: Nullable<string>;
    startVisibleTime?: Nullable<DateTime>;
    endVisibleTime?: Nullable<DateTime>;
    isGoalHidden?: Nullable<boolean>;
    progressBarGoals?: Nullable<ProgressBarGoal[]>;
    pageIds: string[];
    offset?: Nullable<number>;
    pageBucketIds?: Nullable<string[]>;
    dataSources?: Nullable<string[]>;
    isAllPagesLinked?: Nullable<boolean>;
    hideWhenMatchedGivingActive?: Nullable<boolean>;
}

export interface CommentAggregationSetting extends AggregationSetting {
    isAllPagesLinked?: Nullable<boolean>;
    groupSettings?: Nullable<CommentAggregationSettingItem[]>;
}

export interface CommentAggregationSettingItem extends AggregationSettingItem {
    groupId: string;
    groupName?: Nullable<string>;
    startVisibleTime?: Nullable<DateTime>;
    endVisibleTime?: Nullable<DateTime>;
    amountToShowOver?: Nullable<number>;
    pageIds: string[];
    pageBucketIds?: Nullable<string[]>;
    dataSources?: Nullable<string[]>;
    isAllPagesLinked?: Nullable<boolean>;
}

export interface MatchedGivingAggregationSetting extends AggregationSetting {
    isAllPagesLinked?: Nullable<boolean>;
    groupSettings?: Nullable<MatchedGivingAggregationSettingItem[]>;
}

export interface MatchedGivingAggregationSettingItem extends AggregationSettingItem {
    groupId: string;
    groupName?: Nullable<string>;
    matchedGivingSettingIds: string[];
    pageIds: string[];
    pageBucketIds?: Nullable<string[]>;
    dataSources?: Nullable<string[]>;
    isAllPagesLinked?: Nullable<boolean>;
}

export interface CountdownTimerAggregationSetting extends AggregationSetting {
    isAllPagesLinked?: Nullable<boolean>;
    groupSettings?: Nullable<CountdownTimerAggregationSettingItem[]>;
}

export interface CountdownTimerAggregationSettingItem extends AggregationSettingItem {
    groupId: string;
    groupName?: Nullable<string>;
    finishTime?: Nullable<DateTime>;
    startVisibleTime?: Nullable<DateTime>;
    endVisibleTime?: Nullable<DateTime>;
    pageIds: string[];
    pageBucketIds?: Nullable<string[]>;
    dataSources?: Nullable<string[]>;
    isAllPagesLinked?: Nullable<boolean>;
    bonusFinishTimes?: Nullable<DateTime[]>;
}

export interface CampaignAnalyticsSettings {
    pixelConversionsApi?: Nullable<CampaignPixelSetting>;
    gtm?: Nullable<CamaignGtmSetting>;
    ga4?: Nullable<CamaignGa4Setting>;
}

export interface CampaignPixelSetting {
    pixelSettingId?: Nullable<string>;
    isDisabled?: Nullable<boolean>;
}

export interface CamaignGtmSetting {
    gtmSettingId?: Nullable<string>;
    isDisabled?: Nullable<boolean>;
}

export interface CamaignGa4Setting {
    ga4SettingId?: Nullable<string>;
    isDisabled?: Nullable<boolean>;
}

export interface CampaignTrigger {
    campaignTriggerId?: Nullable<string>;
    dateTimeTriggers: DateTimeTrigger[];
}

export interface DateTimeTrigger {
    dateTimeStart: DateTime;
    pageId: string;
    amountTriggers: AmountTrigger[];
}

export interface AmountTrigger {
    amountStart: number;
    pageId: string;
}

export interface CharityTemplateDetail {
    id: string;
    name?: Nullable<string>;
    screenshotImageUrl?: Nullable<string>;
    layout?: Nullable<Page>;
}

export interface Charity {
    id: string;
    isActive: boolean;
    name: string;
    description: string;
    logo: string;
    url?: Nullable<string>;
}

export interface CharityAsset {
    id: string;
    url: string;
    fileName: string;
    categoryType: AssetCategoryType;
}

export interface Role {
    roleId: string;
    roleName: string;
}

export interface CharityUser {
    userId: string;
    email: string;
    name?: Nullable<string>;
    role?: Nullable<Role>;
}

export interface CharityUserWithPagination {
    totalRecords: number;
    items: CharityUser[];
}

export interface CreateCharityResult {
    charityId: string;
    charityUserId: string;
}

export interface CharityTaxSummaryStatus {
    isSendLogExists: boolean;
    totalEmailCount?: Nullable<number>;
    status?: Nullable<CharityTaxSummarySendLogStatus>;
}

export interface CreatePaypalReferralLinkResponse {
    referralLink: string;
    referralToken: string;
    merchantEmail: string;
}

export interface CharityPaymentSettings {
    stripe?: Nullable<CharityStripeSettings[]>;
    payPal?: Nullable<CharityPayPalSettings[]>;
    offline?: Nullable<CharityOfflineSettings[]>;
    platformFeeType?: Nullable<PlatformFeeType>;
}

export interface SetPaymentProviderSettingsResponse {
    label: string;
}

export interface CharityStripeSettings {
    id: string;
    label?: Nullable<string>;
    accountId: string;
    providerType?: Nullable<PaymentProviderType>;
    isDefault?: Nullable<boolean>;
}

export interface CharityPayPalSettings {
    id: string;
    label?: Nullable<string>;
    merchantEmail?: Nullable<string>;
    providerType?: Nullable<PaymentProviderType>;
    isDefault?: Nullable<boolean>;
}

export interface CharityOfflineSettings {
    id: string;
    label?: Nullable<string>;
    accountId: string;
    providerType?: Nullable<PaymentProviderType>;
}

export interface MergeFieldSetting {
    MergeFieldSettingId: string;
    QueryParameter: string;
    CsvHeader?: Nullable<string>;
    MergeTag: string;
    TemplateName?: Nullable<string>;
    MergeFieldName: string;
    MergeTagFallback?: Nullable<string>;
    MergeTagType?: Nullable<MergeTagType>;
    MergeTagDisplayText?: Nullable<string>;
    MergeTagOptions?: Nullable<JSON>;
    IsAnimated?: Nullable<boolean>;
}

export interface CharityDetail {
    abn?: Nullable<string>;
    name?: Nullable<string>;
    phone?: Nullable<string>;
    email?: Nullable<string>;
    description?: Nullable<string>;
    logoUrl?: Nullable<string>;
    reversedLogoUrl?: Nullable<string>;
    faviconUrl?: Nullable<string>;
    fromName?: Nullable<string>;
    fromEmail?: Nullable<string>;
    isDgrEndorsed?: Nullable<boolean>;
    sendPdfReceipt?: Nullable<boolean>;
    autoSendTaxSummaryEmailDate?: Nullable<string>;
    branding?: Nullable<string>;
    domain?: Nullable<string>;
}

export interface CharityPageRedirectionSetting {
    id: string;
    to?: Nullable<CharityPageRedirectionSettingItem>;
    externalTo?: Nullable<string>;
    from: CharityPageRedirectionSettingItem[];
}

export interface CharityPageRedirectionSettingItem {
    id: string;
    type: PageRedirectType;
    name: string;
    campaignName?: Nullable<string>;
    campaignId: string;
}

export interface ApiDonationCharityPageRedirectionSettings {
    to?: Nullable<string>;
    from: string;
    type: PageRedirectType;
}

export interface ApiDonationCharitySettings {
    redirectUrl?: Nullable<string>;
}

export interface CharityDonorPortalRegularGivingPermissions {
    canEditName: boolean;
    canEditAmount: boolean;
    canEditFrequency: boolean;
    canEditDonationEndDate: boolean;
    canEditNextPaymentDate: boolean;
    canCancelDonation: boolean;
    canPauseDonation: boolean;
    canResumeDonation: boolean;
    updatePaymentDetails: UpdatePaymentMethodPermission;
}

export interface CharityDonorPortalSettings {
    branding?: Nullable<string>;
    domain?: Nullable<string>;
    regularGivingPermissions?: Nullable<CharityDonorPortalRegularGivingPermissions>;
}

export interface DonatedTo {
    name: string;
    slug: string;
}

export interface Comment {
    id: string;
    message?: Nullable<string>;
    amount: number;
    donatedBy: string;
    donatedAt: DateTime;
    donatedTo?: Nullable<DonatedTo>;
    matchedAmount?: Nullable<number>;
    matchedDonationAmount?: Nullable<number>;
    dedicateeName?: Nullable<string>;
    organisationName?: Nullable<string>;
}

export interface CommentsQueryResult {
    comments: Comment[];
    totalRecords: number;
}

export interface ElementSettings {
    progressBar?: Nullable<ProgressBarAggregationSettingItem>;
    matchedGivings?: Nullable<CampaignMatchedGivingSetting[]>;
}

export interface Page {
    id: string;
    name?: Nullable<string>;
    branding?: Nullable<string>;
    header?: Nullable<Header>;
    footer?: Nullable<Footer>;
    components: PageComponent[];
    desktop: OrderComponent[];
    mobile?: Nullable<OrderComponent[]>;
    index: number;
    versionNumber?: Nullable<number>;
    charityPageTemplateId?: Nullable<string>;
    charityPageTemplateVersion?: Nullable<number>;
    elementSettings?: Nullable<ElementSettings>;
}

export interface OrderComponent {
    id: string;
    childComponents?: Nullable<OrderComponent[]>;
}

export interface Comments extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    showAmount: boolean;
    showMessage: boolean;
    showTotal: boolean;
    showViewAll: boolean;
    layout: CommentsLayout;
    start?: Nullable<DateTime>;
    end?: Nullable<DateTime>;
    hideBeforeStart?: Nullable<boolean>;
    hideOnEnd?: Nullable<boolean>;
    amountToShowOver?: Nullable<number>;
    isAllPagesLinked?: Nullable<boolean>;
    linkedPageIds?: Nullable<string[]>;
}

export interface Header extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    hasDonateButton: boolean;
}

export interface Footer extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    taxDeductibleText?: Nullable<string>;
    taxDeductible?: Nullable<Text>;
    keyInformationText?: Nullable<string>;
    keyInformation?: Nullable<Text>;
}

export interface Image extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    url?: Nullable<string>;
    alt?: Nullable<string>;
    mergeFieldId?: Nullable<string>;
}

export interface BonusGoal {
    index: number;
    text?: Nullable<Text>;
    isTickHidden?: Nullable<boolean>;
    showPastGoals?: Nullable<boolean>;
    customTickUrl?: Nullable<string>;
    customTickColor?: Nullable<string>;
}

export interface ProgressBar extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    title?: Nullable<string>;
    text?: Nullable<Text>;
    goals?: Nullable<number[]>;
    bonusGoals?: Nullable<BonusGoal[]>;
    finalGoal?: Nullable<BonusGoal>;
    start?: Nullable<DateTime>;
    end?: Nullable<DateTime>;
    hideOnEnd?: Nullable<boolean>;
    hideBeforeStart?: Nullable<boolean>;
    hideOnGoalReached?: Nullable<boolean>;
    hideWhenMatchedGivingActive?: Nullable<boolean>;
    isAllPagesLinked?: Nullable<boolean>;
    linkedPageIds?: Nullable<string[]>;
    offset?: Nullable<number>;
}

export interface DollarHandle {
    amount: number;
    isPersonalised?: Nullable<boolean>;
    imageUrl?: Nullable<string>;
    description?: Nullable<string>;
    hasImage?: Nullable<boolean>;
    hasDescription?: Nullable<boolean>;
    text?: Nullable<Text>;
}

export interface CustomField {
    id: string;
    name: string;
    fieldDescription?: Nullable<string>;
    elementType: CustomFieldElementType;
    acceptedValues?: Nullable<CustomFieldValue[]>;
}

export interface ExtraField {
    type: ExtraFieldType;
    name: string;
    label: string;
    isRequired: boolean;
    isHidden?: Nullable<boolean>;
    order?: Nullable<number>;
    defaultValue?: Nullable<string>;
    placeholder?: Nullable<string>;
    customField?: Nullable<CustomField>;
    hideLabel?: Nullable<boolean>;
    conditionalFields?: Nullable<ExtraField[]>;
}

export interface DonationForm extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    title?: Nullable<string>;
    text?: Nullable<Text>;
    donationFrequency: DonationFrequency[];
    donationFrequencyDefault?: Nullable<number>;
    dollarHandles: DollarHandle[];
    dollarHandlesDefault?: Nullable<number>;
    matchedGivings?: Nullable<CampaignMatchedGivingSetting[]>;
    minimumAmount?: Nullable<number>;
    legalUrl?: Nullable<string>;
    extraFields: ExtraField[];
}

export interface CountdownTimer extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    finish?: Nullable<DateTime>;
    start?: Nullable<DateTime>;
    end?: Nullable<DateTime>;
    bonusFinishTimes?: Nullable<DateTime[]>;
    hideOnEnd?: Nullable<boolean>;
    hideBeforeStart?: Nullable<boolean>;
}

export interface Video extends Component {
    id: string;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    type: ComponentType;
    title?: Nullable<string>;
    url?: Nullable<string>;
}

export interface Text extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    textValue: string;
    htmlText?: Nullable<string>;
}

export interface Empty extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
}

export interface Column extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    components: PageComponent[];
}

export interface Row extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    components: PageComponent[];
}

export interface Color {
    hex: string;
    rgb: RGBColor;
}

export interface RGBColor {
    a?: Nullable<number>;
    b: number;
    g: number;
    r: number;
}

export interface DollarHandles extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    dollarHandles: DollarHandle[];
}

export interface Button extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    buttonText: string;
    html?: Nullable<string>;
    url?: Nullable<string>;
    target?: Nullable<string>;
    buttonType: string;
}

export interface SocialShare extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    hasLink?: Nullable<boolean>;
    hasTwitter?: Nullable<boolean>;
    hasFacebook?: Nullable<boolean>;
    hasEmail?: Nullable<boolean>;
    hasWhatsApp?: Nullable<boolean>;
    hasLinkedIn?: Nullable<boolean>;
}

export interface LoginFormSubcomponents {
    title?: Nullable<string>;
}

export interface RegisterFormSubcomponents {
    title?: Nullable<string>;
}

export interface PostDonationFormSubcomponents {
    title?: Nullable<string>;
}

export interface LoginForm extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
}

export interface RegisterForm extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    extraFields?: Nullable<ExtraField[]>;
}

export interface FundraiserButton extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    loginForm: LoginForm;
    registerForm: RegisterForm;
}

export interface FundraiserProfileSubcomponents {
    profileName: string;
    socialShare?: Nullable<string>;
}

export interface FundraiserProfile extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
}

export interface Leaderboard extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
}

export interface PageOptions extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    siteTitle?: Nullable<string>;
    faviconUrl?: Nullable<string>;
}

export interface ProgressImage extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
}

export interface ProgressImageSubComponents {
    image: string;
    backgroundImage?: Nullable<string>;
    foregroundText?: Nullable<string>;
}

export interface VirtualGiftSection extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
}

export interface PostDonationForm extends Component {
    id: string;
    type: ComponentType;
    styles?: Nullable<JSON>;
    mobileStyles?: Nullable<JSON>;
    subComponents?: Nullable<JSON>;
    buttonText: string;
    extraFields: ExtraField[];
}

export interface FormValue {
    customFieldSettingId?: Nullable<string>;
    name?: Nullable<string>;
    values?: Nullable<Nullable<string>[]>;
}

export interface FormData {
    id: string;
    formId: string;
    formValues: FormValue[];
}

export interface FormDataQueryResult {
    headers: string[];
    formData: FormData[];
}

export interface CustomFieldValue {
    key: string;
    value: string;
}

export interface CustomFieldSetting {
    id: string;
    name: string;
    description?: Nullable<string>;
    type: CustomFieldType;
    elementType: CustomFieldElementType;
    defaultValue?: Nullable<string>;
    acceptedValues?: Nullable<CustomFieldValue[]>;
}

export interface DonorPortalSlugResponse {
    charityId: string;
    branding?: Nullable<string>;
    donorPortalRegularGivingPermissions: CharityDonorPortalRegularGivingPermissions;
}

export interface DonorProfile {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
}

export interface FeatureFlag {
    key: string;
    enabled: boolean;
}

export interface ProfileData {
    id: string;
    name: string;
    logoUrl?: Nullable<string>;
    description?: Nullable<string>;
    goal?: Nullable<number>;
    progressAmount?: Nullable<number>;
    profileUrl?: Nullable<string>;
    owner?: Nullable<ProfileOwnerData>;
    status?: Nullable<ProfileStatus>;
    category?: Nullable<string>;
    campaignId?: Nullable<string>;
    isGivingNotificationEnabled?: Nullable<boolean>;
}

export interface ProfileOwnerData {
    firstName: string;
    lastName: string;
    email: string;
}

export interface ProfileCategory {
    id: string;
    name: string;
    profileEntity?: Nullable<ProfileEntity>;
}

export interface RegisterProfileResult {
    profileId: string;
    redirectUrl: string;
}

export interface AuthenticateProfileResponse {
    token: string;
    profileUrl: string;
}

export interface RegisterEmailResponse {
    token: string;
    hasProfileInCampaign: boolean;
    isExistingUser: boolean;
}

export interface DonorGivingsQueryResult {
    totalRecords: number;
    items: DonorGiving[];
}

export interface GivingsQueryResult {
    totalRecords: number;
    items: Giving[];
}

export interface Giving {
    givingId: string;
    donatedAmount: number;
    refundedAmount: number;
    currencyCode: string;
    donorPaysAmount?: Nullable<number>;
    platformFeesAmount?: Nullable<number>;
    createdAt: DateTime;
    transactionId?: Nullable<string>;
    paymentMethodType: PaymentMethodType;
    status: GivingStatus;
    stripe?: Nullable<GivingStripeTransactionDetail>;
    paypal?: Nullable<GivingPaypalTransactionDetail>;
    donor?: Nullable<GivingDonorDetail>;
    page: GivingPageDetail;
    campaign: GivingCampaignDetail;
    comment?: Nullable<GivingCommentDetail>;
    donationFrequency: GivingDonationFrequency;
}

export interface DonorGiving {
    givingId: string;
    amount: number;
    createdAt: DateTime;
    name?: Nullable<string>;
    status: GivingStatus;
    campaignTitle?: Nullable<string>;
    paymentMethodType: PaymentMethodType;
    donationFrequencyType: GivingDonationFrequency;
}

export interface GivingCommentDetail {
    commentId: string;
    message?: Nullable<string>;
}

export interface GivingStripeTransactionDetail {
    paymentIntentId?: Nullable<string>;
}

export interface GivingPaypalTransactionDetail {
    orderId: string;
    captureId?: Nullable<string>;
}

export interface GivingDonorDetail {
    donationFormFirstName?: Nullable<string>;
    donationFormLastName?: Nullable<string>;
    externalFirstName?: Nullable<string>;
    externalLastName?: Nullable<string>;
    fullName?: Nullable<string>;
    email?: Nullable<string>;
}

export interface GivingPageDetail {
    pageName?: Nullable<string>;
    pageId: string;
}

export interface GivingCampaignDetail {
    campaignTitle?: Nullable<string>;
    campaignId: string;
}

export interface AggregatedGivings {
    total?: Nullable<number>;
    amounts: AggregatedGiving[];
}

export interface AggregatedGiving {
    date: DateTime;
    amount: number;
}

export interface CampaignMatchedGivingSetting {
    id: string;
    name: string;
    startAt: string;
    endAt?: Nullable<string>;
    rounds: CampaignMatchedGivingSettingItem[];
}

export interface CampaignMatchedGivingSettingItem {
    multiplier: number;
    startFundRange: number;
    endFundRange: number;
}

export interface AddCampaignMatchedGivingSettingResult {
    id: string;
}

export interface MatchedGivingProgressResult {
    amount: number;
}

export interface MatchedGivingQueryResult {
    totalRecords: number;
    items: MatchedGivingRecord[];
}

export interface MatchedGivingRecord {
    createdAt: DateTime;
    matchedGivingSettingName: string;
    givingAmount: number;
    matchedDonationAmount: number;
    matchedAmount: number;
    multiplier: number;
    totalAmount: number;
    donorEmail: string;
    donorName: string;
    campaignTitle: string;
    pageName: string;
    matchedGivingId: string;
    givingId: string;
}

export interface MergeField {
    id: string;
    name: string;
    tag: string;
}

export interface CharityMetadata {
    CharityName?: Nullable<string>;
    Phone?: Nullable<string>;
    Email?: Nullable<string>;
    ABN?: Nullable<string>;
    CustomFields?: Nullable<string>;
    FaviconUrl?: Nullable<string>;
    LogoUrl?: Nullable<string>;
    ReversedLogoUrl?: Nullable<string>;
}

export interface CampaignMetadata {
    CampaignName?: Nullable<string>;
    CampaignGoal?: Nullable<string>;
    ogTitle?: Nullable<string>;
    ogImage?: Nullable<string>;
    gtmScriptId?: Nullable<string>;
    ga4ScriptId?: Nullable<string>;
    fbPixelId?: Nullable<string>;
    isConversionsApi?: Nullable<boolean>;
}

export interface PageMetadata {
    OgDescription?: Nullable<string>;
    pageKeywords?: Nullable<string>;
    OgTitle?: Nullable<string>;
    OgImage?: Nullable<string>;
}

export interface Metadata {
    page?: Nullable<PageMetadata>;
    campaign?: Nullable<CampaignMetadata>;
    charity?: Nullable<CharityMetadata>;
}

export interface Appeal {
    name: string;
    id: string;
    rows: Nullable<Row>[];
}

export interface SlugResponse {
    charityId: string;
    campaignId: string;
    pageId?: Nullable<string>;
    pageBucketId?: Nullable<string>;
    profileId?: Nullable<string>;
    layout: Page;
    profileData?: Nullable<ProfileData>;
    campaignSettings?: Nullable<CampaignSettings>;
    redirectUrl?: Nullable<string>;
}

export interface SalesforceContact {
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    email?: Nullable<string>;
}

export interface PageResponse {
    id: string;
}

export interface PageDetail {
    id: string;
    name?: Nullable<string>;
    type?: Nullable<PageType>;
    status: PageStatusType;
    slug?: Nullable<string>;
    index: number;
    hasBeenPublished?: Nullable<boolean>;
    publishedAt?: Nullable<DateTime>;
    screenshotImageUrl?: Nullable<string>;
    pageBucketId?: Nullable<string>;
}

export interface PageBucketDetail {
    id: string;
    name?: Nullable<string>;
    slug?: Nullable<string>;
    pageIds?: Nullable<string[]>;
}

export interface CreateOrderResponse {
    id?: Nullable<string>;
    status?: Nullable<string>;
    payerActionUrl?: Nullable<string>;
    orderUrl?: Nullable<string>;
    aggregateId: string;
}

export interface CreatePaymentIntentResponse {
    paymentTransactionId: string;
    clientSecret: string;
    paymentIntentId?: Nullable<string>;
}

export interface CreateSubscriptionResponse {
    subscriptionId: string;
    clientSecret: string;
    paymentSubscriptionId: string;
}

export interface UpdatePaymentIntentResponse {
    paymentIntentId?: Nullable<string>;
    clientSecret?: Nullable<string>;
}

export interface UpdateSubscriptionResponse {
    subscriptionId?: Nullable<string>;
    clientSecret?: Nullable<string>;
}

export interface PrevalidateDonation {
    charityId: string;
    campaignId: string;
    pageId: string;
    donationFormAmount: number;
    ipAddress: string;
}

export interface PaymentSettings {
    donationPagePaymentProviderSettings: DonationPagePaymentProviderSettings;
    donorPaysPlatformFees?: Nullable<Nullable<PlatformFee>[]>;
    tax?: Nullable<Tax>;
    platformFeeType: PlatformFeeType;
}

export interface Tax {
    countryCodeIso2: string;
    label?: Nullable<string>;
    percentage: number;
}

export interface DonationPagePaymentProviderSettings {
    stripePaymentSettings?: Nullable<StripePaymentSettings>;
    payPalMerchantSetting?: Nullable<PayPalMerchantSetting>;
}

export interface StripePaymentSettings {
    publishableKey?: Nullable<string>;
    connectAccountId?: Nullable<string>;
    paymentProviderType?: Nullable<PaymentProviderType>;
    paymentChargeType?: Nullable<PaymentChargeType>;
    platformAccountId?: Nullable<string>;
    isConnectAccountLive?: Nullable<boolean>;
}

export interface PayPalMerchantSetting {
    clientId?: Nullable<string>;
    merchantId?: Nullable<string>;
    merchantEmail?: Nullable<string>;
}

export interface FeeRange {
    startRange?: Nullable<number>;
    endRange?: Nullable<number>;
    fixFee?: Nullable<number>;
    percentageFee?: Nullable<number>;
}

export interface PlatformFee {
    platformFeeType: PlatformFeeType;
    givingType: GivingType;
    givingFrequencyType: GivingFrequencyType;
    paymentProviderType: PaymentProviderType;
    feeRanges?: Nullable<FeeRange[]>;
}

export interface PaymentTransaction {
    givingId: string;
    createdAt: DateTime;
    transactionExternalData: TransactionExternalData;
    paymentTransaction?: Nullable<PaymentTransactionDetail>;
    refundTransaction?: Nullable<RefundTransactionDetail>;
    applicationFeeTransaction?: Nullable<ApplicationFeeRefundTransactionDetail>;
    netPaymentTransactionAmount: number;
}

export interface ApplicationFeeRefundTransactionDetail {
    applicationFeeAmount: number;
}

export interface PaymentTransactionDetail {
    transactionAmount: number;
    donationFormAmount: number;
    transactionFees: TransactionFees;
    charityTipAmount?: Nullable<number>;
}

export interface RefundTransactionDetail {
    transactionAmount: number;
    donationFormAmount: number;
}

export interface TransactionFees {
    internalManagedAdminFee?: Nullable<number>;
    paymentGatewayFee?: Nullable<number>;
    platformFee?: Nullable<number>;
    totalFee: number;
    totalTax?: Nullable<number>;
}

export interface PaymentTransactionQueryResult {
    totalRecords: number;
    items: PaymentTransaction[];
}

export interface TransactionExternalData {
    paymentServiceTransactionId: string;
    stripeData?: Nullable<StripeTransactionExternalData>;
    payPalData?: Nullable<PayPalTransactionExternalData>;
    offlineData?: Nullable<OfflineTransactionExternalData>;
}

export interface StripeTransactionExternalData {
    connectId: string;
    paymentIntentId: string;
}

export interface PayPalTransactionExternalData {
    merchantId: string;
    merchantEmail: string;
    orderId: string;
    captureId: string;
}

export interface OfflineTransactionExternalData {
    offlineTransactionId: string;
}

export interface Payout {
    id: string;
    payoutDate: DateTime;
    startAt: DateTime;
    endAt: DateTime;
    transferAmount: number;
    paymentTransaction?: Nullable<PaymentTransactionDetail>;
    refundTransaction?: Nullable<RefundTransactionDetail>;
    applicationFeeTransaction?: Nullable<ApplicationFeeRefundTransactionDetail>;
    status?: Nullable<PayoutStatus>;
}

export interface Balance {
    count: number;
    totalAmount: number;
}

export interface PayoutQueryResult {
    items: Payout[];
    totalRecords: number;
}

export interface PreviewQueryResult {
    page: Page;
    campaignSettings?: Nullable<CampaignSettings>;
    metadata?: Nullable<Metadata>;
    profiles?: Nullable<ProfileData[]>;
}

export interface ProgressBarAmount {
    amount?: Nullable<number>;
}

export interface PaginationResponse {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    next?: Nullable<string>;
    prev?: Nullable<string>;
    hasNext: boolean;
    hasPrev: boolean;
}

export interface SubscriptionRecord {
    subscriptionId: string;
    firstName?: Nullable<string>;
    lastName?: Nullable<string>;
    email: string;
    donationFormAmount: number;
    transactionAmount: number;
    currencyCode: string;
    externalSubscriptionId: string;
    paymentMethodType: PaymentMethodType;
    startAt: DateTime;
    endAt?: Nullable<DateTime>;
    totalGivingTransactionAmount: number;
    donationFrequencyType: GivingDonationFrequency;
    status: SubscriptionStatus;
    campaign: string;
    page: string;
    subscriptionStartAt: DateTime;
    lastInvoice?: Nullable<SubscriptionInvoice>;
    lastGiving?: Nullable<SubscriptionRegularGiving>;
    scheduledUpdate?: Nullable<SubscriptionScheduledUpdate>;
    resumeAt?: Nullable<DateTime>;
    nextPaymentDate?: Nullable<DateTime>;
}

export interface SubscriptionRegularGiving {
    givingDate: DateTime;
    givingStatus: GivingStatus;
}

export interface SubscriptionInvoice {
    invoiceDate: DateTime;
    invoiceStatus: SubscriptionInvoiceStatus;
}

export interface SubscriptionScheduledUpdate {
    subscriptionScheduleId: string;
    externalSubscriptionScheduleId: string;
    startAt?: Nullable<DateTime>;
    amount?: Nullable<number>;
    donationFrequencyType?: Nullable<GivingDonationFrequency>;
}

export interface UpdateSubscriptionAdminResponse {
    externalSubscriptionScheduleId?: Nullable<string>;
    paymentSubscriptionScheduleId?: Nullable<string>;
}

export interface SubscriptionsQueryResult {
    totalRecords: number;
    items: SubscriptionRecord[];
}

export interface DonorSubscriptionsQueryResult {
    totalRecords: number;
    items: DonorSubscription[];
}

export interface DonorSubscription {
    subscriptionId: string;
    amount: number;
    createdAt: DateTime;
    name?: Nullable<string>;
    status: SubscriptionStatus;
    campaignTitle?: Nullable<string>;
    externalSubscriptionId: string;
    paymentMethodType: PaymentMethodType;
    nextPaymentDate?: Nullable<DateTime>;
    subscriptionStartDate: DateTime;
    subscriptionEndDate?: Nullable<DateTime>;
    frequency: GivingDonationFrequency;
    regularGivings: DonorSubscriptionRegularGiving[];
    resumeAt?: Nullable<DateTime>;
    lastInvoice?: Nullable<SubscriptionInvoice>;
    scheduledUpdate?: Nullable<SubscriptionScheduledUpdate>;
}

export interface DonorSubscriptionRegularGiving {
    regularGivingId: string;
    amount: number;
    createdAt: DateTime;
    name?: Nullable<string>;
    status: GivingStatus;
    paymentMethodType: PaymentMethodType;
}

export interface StripeSubscriptionDonorPortalLink {
    url: string;
}

export type JSON = any;
export type DateTime = any;
export type PageComponent = ProgressBar | Image | Text | Empty | Row | Column | Video | CountdownTimer | DonationForm | Header | Comments | Footer | DollarHandles | Button | SocialShare | LoginForm | RegisterForm | FundraiserButton | FundraiserProfile | Leaderboard | PageOptions | ProgressImage | VirtualGiftSection | PostDonationForm;
type Nullable<T> = T | null;
